import React, {useEffect, useState, useRef} from 'react';
import {getAccountDetails, getWeeks, setName, getTeamDetails, registerAccount, updateHiLo } from './helpers/apihandler';
import { disconnectWallet} from './helpers/wallet.js'
import { AccountName } from './accountName';
import maticimg from '../images/matic.png';
import pearlimg from '../images/prl-small.png';
import { CollList } from './collList';
import { LeaderBoard } from './leaderBoard';
import { Lobby } from './lobby';
import { getRacers, stakeRacers, getStakedRacers, getSetCoaches, setLeagueCoach, setRoles, unstakeRacers, moveRacers, updateName, getTransferFaves, checkTransferStatus, checkAllTransferStatus, checkSignature, setSignature, getManagementStyles, setLeagueManagement, getManagementStyleBonuses,getHydrolyteByRacerReg, getStoredHydro, assignHydro } from './helpers/racefunctions';
import { NFTGridCoachSelectable } from './nftGridCoachSelectable';
import { NFTGridRolesSelectable } from './nftGridRolesSelectable';
import { NFTGridChangesSelectable } from './nftGridChangesSelectable';
import { NFTGridMysterySelectable } from './nftGridMysterySelectable';
import {MintPanel} from './mintPanel';
import {RacesList} from './racesList';
import { LookingFor } from './lookingFor';
import { ViewRecords } from './viewRecords';
import { CoachContest } from './coachContest';
import { TransferManagement } from './transferManagement';
import rookie from '../images/rookie.png';
import vet from '../images/vet.png';
import elite from '../images/elite.png';
import { Modal } from 'bootstrap';
import star from '../images/star.svg';
import plus from '../images/plus.svg';
import minus from '../images/minus.svg';
import unsetrole from '../images/unset_role.png';
import anchorimg from '../images/Anchor.svg';
import captainimg from '../images/Captain.svg';
import asscapimg from '../images/Ass_Captain.svg';
import equipimg from '../images/Equip_manager.svg';
import benchimg from '../images/Bench_Warmer.svg';
import hydroimg from '../images/hydrolyte.svg';

function MenuDisplay ({menuSelection, walletAddress, setMessage, setModalInfo, maticAvail, pearlsAvail, mintsAvail, currcollections, stakedRacers, weekInfo, currWeek, accountName, setAccountName, setCurrStakedRacers, leagueToManage, currManagementSel, selectManageSection, hydroAvail, setStatus, setWallet}) {

    const display = "Registered / Unregistered";
    const [accountDetails, setAccountDetails] = useState({});
    const [collectionslist, setCollections] = useState([]);
    const [regSelection, setRegSelection] = useState("league");
    const [regInfo, setRegInfo] = useState({});
    const [selectedCoach, setSelectedCoach] = useState({});
    const [registeredCoach, setRegCoach] = useState({});
    const [selectedRacers, setSelectedRacers] = useState([]);
    const [coachArray, setCoachArray] = useState([]);
    const [coachRegArray, setCoachRegArray] = useState([]);
    const [racerArray, setRacerArray] = useState([]);
    const [todaysDate, setTodaysDate] = useState("");
    const [confirmStats, setConfirmStats] = useState({});
    const [coachChange, setCoachChange] = useState("no");
    const [currentRoles, setCurrentRoles] = useState({});
    const [prevSetRoles, setPrevSetRoles] = useState({});
    const [roleSelItems, setRoleSelItems] = useState([]);
    const [changesSelItems, setChangeSelItems] = useState([]);
    const [selectChanges, setSelectChanges] = useState([]);
    const [selectMystery, setSelectMystery] = useState([]);
    const [mysterySelItems, setMysterySelItems] = useState([]);
    const [pendingRoleChanges, setPendingRoleChanges] = useState("no");
    const [weeks, setWeeks] = useState([]);
    const [moveTo, setMoveTo] = useState("");
    const pearlRookieCost = '0';
    const maticRookieCost = '0.25';
    const maticVetCost = '.025';
    const pearlVetCost = 0;
    const pearlEliteCost = (weekInfo.weekinfo !== undefined ? (weekInfo.weekinfo.season_week === "5" ? '0' : '500') : '');
    const maticEliteCost = (weekInfo.weekinfo !== undefined ? (weekInfo.weekinfo.season_week === "5" ? '0' : '.35') : '');
    const pearlRegattaTeamRookCost = '0';
    const maticRegattaTeamRookCost = '5';
    const pearlRegattaTeamEliteCost = '5000';
    const maticRegattaTeamEliteCost = '10';
    const pearlSharkTOneEliteCost = '600';
    const maticSharkTOneEliteCost = '6';
    const pearlSharkTTwoEliteCost = '400';
    const maticSharkTTwoEliteCost = '4';
    const pearlSharkTThreeEliteCost = '200';
    const maticSharkTThreeEliteCost = '2';
    const pearlSharkTOneRookCost = '0';
    const maticSharkTOneRookCost = '6';
    const pearlSharkTTwoRookCost = '0';
    const maticSharkTTwoRookCost = '4';
    const pearlSharkTThreeRookCost = '0';
    const maticSharkTThreeRookCost = '2';

    const currWeekDisp = parseInt(currWeek);
    const [showChange, setShowChange] = useState([false,false,false,false]);
    const accForChange = useRef("");
    const [transfersAllowed, setTransfersAllowed] = useState(false);
	const [transferFavs, setTransferFavs] = useState([]);
    const [transferWallets, setTransferWallets] = useState([]);
    const [transferAllAllowed, setTransferAllAllowed] = useState(false);
    const [localHiLo, setHilo] = useState("");
    const [selectedManagement, setSelectedManagement] = useState("");
//    const [userSelectedManage, setUserSelectedMange] = useState([0,0,0,0]);
    const [currentSelManageStyle, setCurrentSelManageStyle] = useState([0,0,0,0])
//    const [manageChange, setManageChange] = useState("no");
    const managementStyles = getManagementStyles();
    const [pendingHydro, setPendingHydro] = useState(0);
    const [leagueHydro, setLeagueHydro] = useState([0,0,0]);
    const [pendingHydroRacers, setPendingHydroRacers] = useState([]);

    useEffect(() =>{

        const loadInit = async() => {
            var myCreateModal = new Modal(document.getElementById('showAlerts'));
            myCreateModal.show();
            setModalInfo({"message":"Loading account information please wait.", "type":"loadingracers" });
            let dets = await getAccountDetails(walletAddress);
            
            if (dets.message === "missing"){
                let signresp = await checkSignature(walletAddress);
                
                    if (!signresp) {
                        let txt = "You must be at least 18 years old to take part in this event. By clicking OK and confirming the following transaction you agree that you are at least 18 years old.";
    
                        if (window.confirm(txt)) {
                            let tx = await setSignature();
                            //console.log(tx);
                            if (tx !== undefined) {
                                await registerAccount(walletAddress, tx.hash);
                            }else{
                            myCreateModal.hide();
                            alert('You must agree to be able to race.');
                            const disconnReponse = await disconnectWallet();
                            setStatus(disconnReponse.status);
                            await setWallet(disconnReponse.address);
                            return false;
                            }
                        }else{
                            
                            
                            alert('You must agree to be able to race.');
                            const disconnReponse = await disconnectWallet();
                            setStatus(disconnReponse.status);
                            await setWallet(disconnReponse.address);
                            myCreateModal.hide();
                            return false;
                        }
                    } 
                    //console.log(signresp);
            }
            //console.log(dets);
            setAccountDetails(dets);
            const setCoaches = await getSetCoaches(walletAddress);
            const earnedHydro = await getStoredHydro(walletAddress);
            setCoachRegArray(setCoaches);
            let tempEarnedHydro = [0,parseInt(earnedHydro[1]),parseInt(earnedHydro[2])];
            setLeagueHydro(tempEarnedHydro);
            await loadCollections(0, false, 0);
            getWalletsForTransfer();
            getTransferStatus()
            myCreateModal.hide();
            var today = new Date();

// Get the day of the month
var dd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();

if (dd < 10) {
    dd = '0' + dd;
} 

if (mm < 10) {
    mm = '0' + mm;
} 

    setTodaysDate(mm + '/' + dd + '/' + yyyy);


        }
        const loadWeeks = async() => {
            const loadedWeeks = await getWeeks();
            setWeeks(loadedWeeks); 
        }
        if (Object.keys(weekInfo).length > 0 && walletAddress !== ''){
            loadInit();
        }
            loadWeeks();
        
        


    },[walletAddress, weekInfo])

    useEffect(() =>{
        const loadLeagueInfo = async() => {
        if (leagueToManage !== '' && leagueToManage !== undefined && leagueToManage !== 'Select League'){
            await loadCollections(parseInt(coachRegArray[leagueToManage]), true, leagueToManage);
            getConfirmStats(leagueToManage, []);
            let regObject = regInfo;
            regObject.league = leagueToManage;
            setRegInfo(regObject);
        }
        }
        loadLeagueInfo();
        
    },[leagueToManage])

    const getWalletsForTransfer = async () => {
		if (transferWallets.length > 0) {
			return;
		}
		const walletData = await getTeamDetails(walletAddress);
		setTransferWallets(walletData);
		getTransferFavs(walletData);
        getAllTransferStatus();
	}

    const getTransferFavs = async (passedwallets) => {
		let tempFaves = await getTransferFaves(walletAddress);
				let wallets = (transferWallets.length === 0 ? passedwallets : transferWallets );
				let favesList = [];
				for (let x = 0; x < tempFaves.length; x++ ){
					let fave = {}
					fave.wallet = tempFaves[x];
					fave.name = wallets.filter(y => y.address.toLowerCase() === tempFaves[x].toLowerCase())[0].name;
					favesList.push(fave);
				}
				setTransferFavs(favesList);
	}

    const getTransferStatus = async () => {
		let status = await checkTransferStatus(walletAddress);
		setTransfersAllowed(status);
	}

    const getAllTransferStatus = async () => {
		let status = await checkAllTransferStatus(walletAddress);
		setTransferAllAllowed(status);
	}

    const updateHiLoStatus = async(e, league) => {
        let status = (e.target.checked ? 'lo' : 'hi');
        const updateResp = await updateHiLo(walletAddress, league,  status);
        if (updateResp === "Success") {
          let tempdets = accountDetails;
          if (league === "1"){
            tempdets.hilo = status;
          }else{
            tempdets.hilorookie = status;
          }
          setAccountDetails(tempdets);
          setHilo(status);
        }
    }



    const getConfirmStats = async(league, newstaked) => {

        let lowest = -20;
        let highest = 0;
        let average = 0;
        let totalSpeed = 0;
        let coacharr = [];
        let racersarr = [];
        let tempStakedRacers = [];
        let colllistlocal = [...collectionslist];
        if (newstaked.length > 0){
            tempStakedRacers = newstaked;
        }else{
            tempStakedRacers = stakedRacers;
        }

//        if (Object.keys(selectedCoach).length === 0) {
        for (let x = 0; x < colllistlocal.length; x++){
            if (colllistlocal[x].collection === 'Coach'){
                for (let y = 0; y < colllistlocal[x].racers.length; y++){
                    if (league === "1" && (colllistlocal[x].racers[y].rank === "Elite" || colllistlocal[x].racers[y].rank === "Legendary" || colllistlocal[x].racers[y].rank === "Veteran")){
                        coacharr.push(colllistlocal[x].racers[y]);
                        
                    }
                    else if(league === "2" && colllistlocal[x].racers[y].rank === "Veteran"){
                        coacharr.push(colllistlocal[x].racers[y]);
                    }else if(league === "3" && (colllistlocal[x].racers[y].rank === "Rookie"  || colllistlocal[x].racers[y].rank === "Veteran")){
                        coacharr.push(colllistlocal[x].racers[y]);
                    }

                    if (parseInt(coachRegArray[league]) === parseInt(colllistlocal[x].racers[y].id)){
                        let regObject = regInfo;
                        regObject.selectedCoach = colllistlocal[x].racers[y];
                        setRegInfo(regObject);
                        setSelectedCoach(colllistlocal[x].racers[y]);
                        setRegCoach(colllistlocal[x].racers[y]);

                    }
                }
                
            }
                
            }
//        }
    
        let cap = {};
        let anc = {};
        let ass = {};
        let equ = {};
        let ben = {};
        let allracers = 0;
        for (let x = 0; x < tempStakedRacers.length; x++){
        //    if (tempStakedRacers[x].owner.toLowerCase()  !== walletAddress.toLowerCase()){
        //        continue;
        //    }
            if (parseInt(tempStakedRacers[x].league) !== parseInt(league)){
                continue;
            }
            

            let manStyleTemp = getManagementStyleBonuses(currentSelManageStyle[league],0,0,"speed");
            let localhilo = (league === "1" ? accountDetails.hilo : accountDetails.hilorookie);
            for (let y = 0; y < colllistlocal.length; y++){
                if (colllistlocal[y].collection !== "Coach"){
                    for (let j = 0; j < colllistlocal[y].racers.length; j++){
                        let eventWanted = -1;
                        let league = 0;
                        let leaguewanted = "";
                        let registered = "no";
                        let hydro = 0;
 
                        if (parseInt(colllistlocal[y].racers[j].id) === parseInt(tempStakedRacers[x].id) && colllistlocal[y].racers[j].contract === tempStakedRacers[x].nftContract){
                            let racerspeed = 0;
                            
                            eventWanted = parseInt(tempStakedRacers[x].eventWanted);
                                league = parseInt(tempStakedRacers[x].league);
                                hydro = parseInt(tempStakedRacers[x].hydrolyte);
                                leaguewanted = (league === 1 ? "Elite" : (league === 2 ? "Veteran" : "Rookie")) ;
                                registered = "yes";
                                colllistlocal[y].racers[j].raceid = eventWanted;
                                colllistlocal[y].racers[j].league = league; 
                                colllistlocal[y].racers[j].leaguename = leaguewanted; 
                                colllistlocal[y].racers[j].registered = registered;
                                colllistlocal[y].racers[j].hydro = hydro;
                                colllistlocal[y].racers[j].pendinghydro = 0;
                                racerspeed = colllistlocal[y].racers[j].speedTotal + manStyleTemp + colllistlocal[y].racers[j].roleBoost  + (weekInfo.weekinfo.regatta === "0" ? colllistlocal[y].racers[j].bNum : (localhilo === 'hi' || parseInt(colllistlocal[y].racers[j].raceid) === 1 ? colllistlocal[y].racers[j].bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? colllistlocal[y].racers[j].wBoostB : (localhilo === 'hi' || colllistlocal[y].racers[j].raceid === 1  ? colllistlocal[y].racers[j].wBoostBHi: colllistlocal[y].racers[j].wBoostBLo));
                            
                            if (lowest === -20 || racerspeed < lowest){
                                lowest = racerspeed ;
                            }
                            if (racerspeed  > highest){
                                highest = racerspeed ;
                            }
                            allracers +=1;
                            totalSpeed += racerspeed;
                            if (colllistlocal[y].racers[j].roleName === "Captain"){
                                colllistlocal[y].racers[j].pending = "no";
                                cap = colllistlocal[y].racers[j];
                            }else if (colllistlocal[y].racers[j].roleName === "Anchor"){
                                colllistlocal[y].racers[j].pending = "no";
                                anc = colllistlocal[y].racers[j];
                            }else if (colllistlocal[y].racers[j].roleName === "Assistant Captain"){
                                colllistlocal[y].racers[j].pending = "no";
                                ass = colllistlocal[y].racers[j];
                            }else if (colllistlocal[y].racers[j].roleName === "Equipment Manager"){
                                colllistlocal[y].racers[j].pending = "no";
                                equ = colllistlocal[y].racers[j];
                            }else if (colllistlocal[y].racers[j].roleName === "Bench Warmer"){
                                colllistlocal[y].racers[j].pending = "no";
                                ben = colllistlocal[y].racers[j];
                            }
                            racersarr.push(colllistlocal[y].racers[j]);
                            break;
                        }
                    }

                }
            }
        }
        if (allracers > 0){
            average = totalSpeed / allracers;
        }
        let conf = {};
        let roles = {};
        roles.cap = cap;
        roles.ben = ben;
        roles.ass = ass;
        roles.equ = equ;
        roles.anc = anc;
        conf.average = average.toFixed(0);
        conf.highest = highest;
        conf.lowest = lowest;
        racersarr.sort(function(a, b){return a.id - b.id});
        setConfirmStats(conf);
        setCoachArray(coacharr);
        setRacerArray(racersarr);
        setCurrentRoles(roles);
        setPrevSetRoles(roles);
    }


    const loadCollections = async(coachid, skipcoaches, specificleague) => {
        setCollections([]);
        let temp = [];
        let selManTemp = [0,0,0,0];
        let racers = [];
        for(let x = 0; x < currcollections.length; x++){
            if (skipcoaches && currcollections[x].collection === 'Coach') { continue;}
            temp = await getRacers(walletAddress, currcollections[x].address, coachid, weekInfo, currWeek);
            racers = temp[0];
            if (currcollections[x].collection === 'Racer'){
                selManTemp = temp[1];
            }
            
            currcollections[x].racers = racers;
            currcollections[x].racercount = racers.length;

        }
        setCollections(currcollections);
        if (specificleague > 0){
            setSelectedManagement(selManTemp[specificleague]);
        }
        
        setCurrentSelManageStyle(selManTemp);
        return currcollections;
    }

   const showOrHide = () => {

   }
    
    if (menuSelection === 'account') {
        if (walletAddress === ''){
                        return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access account.</div>)
                }else{    
    return <><div className='col-md-12 row'>
    <div className='col-md-8'>
    <AccountName walletAddress={walletAddress} setMessage={setMessage} setModalInfo={setModalInfo} displayOnly={false} dets={accountDetails} accountName={accountName} setAccountName={setAccountName} />
    </div><div className='col-md-4' style={{marginBottom:'0px', marginTop:'auto'}}><div className='createFormat'><div style={{fontSize:'.7em', marginRight:'5%'}}>{walletAddress}</div></div><div className='createFormat'><span style={{fontWeight:'bold'}}>Balance:</span> <a href="https://quickswap.exchange/#/analytics/v2/token/0xcaf44e62003de4b8bd17c724f2b78cc532550c2f" target="_blank" rel="noreferrer" style={{color:'blue', textDecoration:'none'}}>(buy pearls)</a></div>
    
    <div className='createFormat'><img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> POL: <span style={{fontWeight:'bold'}}>{maticAvail}</span></div>
        <div className='createFormat'><img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> PEARLS: <span style={{fontWeight:'bold'}}>{pearlsAvail}</span></div>
        <div className='createFormat'> Exclusive Mints: <span style={{fontWeight:'bold'}}>{mintsAvail}</span></div>
        <div className='createFormat'> <img src={hydroimg} alt={'hydro logo'} style={{width:'25px', margin:'4px'}}/>Elite: <span style={{fontWeight:'bold'}}>{leagueHydro[1]}</span></div>
        <div className='createFormat'> <img src={hydroimg} alt={'hydro logo'} style={{width:'25px', margin:'4px'}}/>Vet: <span style={{fontWeight:'bold'}}>{leagueHydro[2]}</span></div>
        </div>
    </div>
    <div className='createFormat row' style={{fontWeight:'bold', paddingTop:'20px'}}><div className='col'>My Team:</div><div className='col'><div style={{fontWeight:'bold', display:'none', marginLeft:'10%'}}>{display} <label className="switch"><input type="checkbox" onClick={() => {showOrHide()}} /><span className="slider round"></span></label></div></div></div>
    <div className="row" style={{paddingTop: '10px', display:'flex'}}><div className='col'>
            <CollList collectionslist={collectionslist} transferFavs={transferFavs} transfersAllowed={transfersAllowed} transferAllAllowed={transferAllAllowed} loadCollections={loadCollections} setModalInfo={setModalInfo} walletAddress={walletAddress} weekInfo={weekInfo} accountDetails={accountDetails}/>
            </div></div></>
                }
    }else if (menuSelection === 'registration'){
        if (walletAddress === ''){
            return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access registration.</div>)
        }else{  
            
            const selectLeague = (leg) => {
            if (leg === "2"){
                return false;
            }
            if (leg === "1" && weekInfo.weekinfo.season_week === "5" && !accountDetails.eliteallowed){
                alert('You can only register for elite playoffs if you raced once in the season and your team placed on the leaderboard with 10 other teams. Example: You were ranked 14, but to race in the playoffs there must be at least 20 teams placed otherwise you cannot register.')
                return false;   
            }
            if (leg === "2" && weekInfo.weekinfo.season_week === "5" && !accountDetails.vetallowed){
                alert('You can only register for veteran playoffs if you raced once in the season and your team placed on the leaderboard with 10 other teams. Example: You were ranked 14, to race in the playoffs there must be at least 20 teams placed otherwise you cannot register.')
                return false;   
            }
            if (selectedRacers.filter(x => x.registered === "no" && x.league !== leg).length > 0 ){
                let confresp = window.confirm('You currently have racers selected in another league. Selecting a new league will clear those selections. Are you sure you want to do this?')
                if (confresp){
                    setSelectedRacers([]);
                } else{
                    return false;
                }
                
            }
            let regObject = regInfo;
            regObject.league = leg;
            setRegInfo(regObject);
            loadCoaches(leg);
            setSelectedManagement(currentSelManageStyle[leg]);
            setRegSelection('coach');
            
        }

    const loadCoaches = (leg) => {
        
        let coacharr = [];
        for (let x = 0; x < collectionslist.length; x++){
            if (collectionslist[x].collection === 'Coach'){
                let allowedToAssign = "no";
                for (let y = 0; y < collectionslist[x].racers.length; y++){
                    if (leg === "1" && (collectionslist[x].racers[y].rank === "Elite" || collectionslist[x].racers[y].rank === "Legendary" || collectionslist[x].racers[y].rank === "Veteran")){
                        coacharr.push(collectionslist[x].racers[y]);
                        allowedToAssign = "yes";
                    }
                    else if(leg === "2" && (collectionslist[x].racers[y].rank === "Veteran" || collectionslist[x].racers[y].rank === "Rookie")){
                        coacharr.push(collectionslist[x].racers[y]);
                        allowedToAssign = "yes";
                    }else if(leg === "3"){
                        if (weekInfo.weekinfo.regatta === "1" && (collectionslist[x].racers[y].rank === "Rookie" || collectionslist[x].racers[y].rank === "Veteran")){
                            coacharr.push(collectionslist[x].racers[y]);
                            allowedToAssign = "yes";
                        }else if (weekInfo.weekinfo.sharkweek === "1" && (collectionslist[x].racers[y].rank === "Rookie" || collectionslist[x].racers[y].rank === "Veteran")){
                            coacharr.push(collectionslist[x].racers[y]);
                            allowedToAssign = "yes";
                        }else if (weekInfo.weekinfo.regatta === "0" && collectionslist[x].racers[y].rank === "Rookie"){
                            coacharr.push(collectionslist[x].racers[y]);
                            allowedToAssign = "yes";
                        }
                        
                    }

                    if (parseInt(coachRegArray[leg]) === parseInt(collectionslist[x].racers[y].id) && allowedToAssign === "yes"){
                        let regObject = regInfo;
                        regObject.selectedCoach = collectionslist[x].racers[y];
                        setRegInfo(regObject);
                        setSelectedCoach(collectionslist[x].racers[y]);
                        setRegCoach(collectionslist[x].racers[y]);
                    }
                }
                
            }
           /* else{
                let currRegistered = [];
                for (let y = 0; y < collectionslist[x].racers.length; y++){
                    
                    let eventWanted = -1;
                    let league = 0;
                    let leaguewanted = "";
                    let registered = "no";
                    for (let j = 0; j < stakedRacers.length; j++){
                        if (parseInt(stakedRacers[j].id) === parseInt(collectionslist[x].racers[y].id)){
                            eventWanted = parseInt(stakedRacers[j].eventWanted);
                            league = parseInt(stakedRacers[j].league);
                            leaguewanted = (league === 1 ? "Elite" : (league === 2 ? "Veteran" : "Rookie")) ;
                            registered = "yes";
                            break;
                        }
                        
                    }
                    collectionslist[x].racers[y].raceid = eventWanted;
                        collectionslist[x].racers[y].league = leaguewanted; 
                        collectionslist[x].racers[y].registered = registered;
                        if (registered === "yes"){
                            currRegistered.push(collectionslist[x].racers[y]);
                        }
                    racersarr.push(collectionslist[x].racers[y]);
                }
                if (currRegistered.length > 0){
                    setSelectedRacers(currRegistered);
                }
                
            }*/
        }
        setCoachArray(coacharr);
    }

    const loadRacers = () => {
        let racersarr = [];
        let currRegistered = [];
        for (let x = 0; x < collectionslist.length; x++){
        if (collectionslist[x].collection !== 'Coach'){
            
            for (let y = 0; y < collectionslist[x].racers.length; y++){
                
                let eventWanted = -1;
                let league = 0;
                let leaguewanted = "";
                let registered = "no";
                let hydro = 0;
                for (let j = 0; j < stakedRacers.length; j++){
                //    console.log(stakedRacers[j]);
                //    console.log(collectionslist[x].racers[y]);
                    if (parseInt(stakedRacers[j].id) === parseInt(collectionslist[x].racers[y].id) && stakedRacers[j].nftContract.toLowerCase() === collectionslist[x].racers[y].contract.toLowerCase()){
                        eventWanted = parseInt(stakedRacers[j].eventWanted);
                        hydro = parseInt(stakedRacers[j].hydrolyte);
                        league = parseInt(stakedRacers[j].league);
                        leaguewanted = (league === 1 ? "Elite" : (league === 2 ? "Veteran" : "Rookie")) ;
                        registered = "yes";
                        break;
                    }
                    
                }
                collectionslist[x].racers[y].raceid = eventWanted;
                collectionslist[x].racers[y].league = league;
                    collectionslist[x].racers[y].leaguename = leaguewanted; 
                    collectionslist[x].racers[y].registered = registered;
                    collectionslist[x].racers[y].hydro = hydro;
                    collectionslist[x].racers[y].pendinghyrdo = 0;
                    if (registered === "yes"){
                        currRegistered.push(collectionslist[x].racers[y]);
                    //    console.log(currRegistered);
                    }

                racersarr.push(collectionslist[x].racers[y]);
            }
            
            
        }
    }
    //console.log(currRegistered);
            if (currRegistered.length > 0){
                setSelectedRacers(currRegistered);
            }
        setRacerArray(racersarr);
        
    }
        const selectCoach = async() => {
          /*  if (Object.keys(selectedCoach).length === 0){
                const coachNotSel = window.confirm('You have not selected a coach. Are you sure you want to continue?');
                if (!coachNotSel){
                    return false;
                }
            }*/
            let regObject = regInfo;
            regObject.selectedCoach = selectedCoach;
            setRegInfo(regObject);
            await loadCollections(selectedCoach.id, true);
            loadRacers();
            setRegSelection('racers');
            
            
        }

        
        const submitTeam = async() => {

            const racersToRegister = selectedRacers.filter(x => x.registered === "no" && parseInt(x.league) === parseInt(regInfo.league));
            const currRegistered = selectedRacers.filter(x => x.registered === "yes"  && parseInt(x.league) === parseInt(regInfo.league));
            console.log(selectedRacers);
            console.log(racersToRegister);
            console.log(currRegistered);
            if (racersToRegister.length === 0){
            alert('Please select racers to register.')
             return false;   
            }
            if (weekInfo.weekinfo.regatta === "1"){
                if ((currRegistered.length + racersToRegister.length) !== (parseInt(weekInfo.weekinfo.regattaracecnt) + 1)){
                    alert('Please select ' + weekInfo.weekinfo.regattaracecnt + ' racers and an alternate to register for the regatta.')
                    return false;   
                   }
            }
            var myCreateModal = new Modal(document.getElementById('showAlerts'));
            myCreateModal.show();

                if(selectedManagement !== currManagementSel[regInfo.league] && parseInt(regInfo.league) !== 3){
                    setModalInfo({"message":"Waiting on Management Style submission.", "type":"registerteam" });
                    const manageResults = await setLeagueManagement(regInfo.league, selectedManagement);
                    
                        if (manageResults !== undefined){
                            if (manageResults.blockNumber !== '' && manageResults.blockNumber !== undefined){
                                setModalInfo({"message":"Management Style Set.", "type":"teamregistered" });
                            }else {
                                setModalInfo({"message":'Issue connecting to the blockchain. Please try again. League:' + regInfo.league + ' Coach:' + selectedCoach.id + ' message:' + manageResults.message,"type":'error'});
                                return false;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return false;
        
                        }
                    
                }
           

                if (parseInt(selectedCoach.id) !== parseInt(coachRegArray[regInfo.league]) ) {
                    setModalInfo({"message":"Waiting on Coach submission.", "type":"registerteam" });
 
                    const coachResults = await setLeagueCoach(regInfo.league, selectedCoach.id);
                    
                        if (coachResults !== undefined){
                            if (coachResults.blockNumber !== '' && coachResults.blockNumber !== undefined){
                                setModalInfo({"message":"Coach Registered.", "type":"teamregistered" });
                            }else {
                                setModalInfo({"message":'Issue connecting to the blockchain. Please try again. League:' + regInfo.league + ' Coach:' + selectedCoach.id + ' message:' + coachResults.message,"type":'error'});
                                return false;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return false;
        
                        }
                    

                }
                setModalInfo({"message":"Waiting on Team submission.", "type":"registerteam" });
                const returnResults = await stakeRacers(racersToRegister, currWeek, walletAddress, regInfo.league);
                if (returnResults !== undefined){
                    if (returnResults.blockNumber !== '' && returnResults.blockNumber !== undefined){
                        setModalInfo({"message":"Team Registered.", "type":"teamregistered" });
                    }else {
                        
                        
                            setModalInfo({"message":'Issue connecting to the blockchain. Please try again.' + returnResults,"type":'error'});
                        
                        
                        return false;
                    }
                }else {
                    setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                    return false;

                }

                const newlyStaked = await getStakedRacers();
                setCurrStakedRacers(newlyStaked);
                setRegSelection("confirm");
                getConfirmStats(regInfo.league, newlyStaked);
        }

        const changeRegSel = (sel) => {
            if (sel === "league" && regSelection !== "league"){
                setRegSelection("league");
            }else if (sel === "coach" && regSelection !== "league"){
                setRegSelection("coach");
            }else if (sel === "racers" && regInfo.selectedCoach !== undefined){
                setRegSelection("racers");
            }else if (sel === "confirm" && selectedRacers.length > 0){
                let currRegistered = selectedRacers.filter(x => x.registered === "yes").length;
                if (currRegistered > 0){
                    setRegSelection("confirm");
                    getConfirmStats(regInfo.league, []);
                }
                
            }
        }

        
        return <div>
            <div className='col-md-12' id='regmenu' style={{paddingTop:'30px', textAlign:'center', paddingBottom:'30px'}}><button style={{paddingRight:'20px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline', color:(regSelection === 'league' ? 'white' : 'blue'), fontWeight:(regSelection === 'league' ? 'bold' : 'normal')}} onClick={() => changeRegSel('league')}>Select League &gt;</button> <button style={{paddingRight:'20px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline', color:(regSelection === 'coach' ? 'white' : 'blue'), fontWeight:(regSelection === 'coach' ? 'bold' : 'normal')}} onClick={() => changeRegSel('coach')}>Select Coach &gt;</button> <button style={{paddingRight:'20px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline', color:(regSelection === 'racers' ? 'white' : 'blue'), fontWeight:(regSelection === 'racers' ? 'bold' : 'normal')}} onClick={() => changeRegSel('racers')}>Select Racers &gt;</button> <button style={{color:(regSelection === 'confirm' ? 'white' : 'blue'), background:'none', border:'none', cursor:'pointer', textDecoration:'underline', fontWeight:(regSelection === 'confirm' ? 'bold' : 'normal')}} onClick={() => changeRegSel('confirm')}>Confirmation</button></div> 
        <div className='col-md-12 row' id='selectLeague' style={{display:(regSelection === 'league' ? 'flex' : 'none')}}>
            <div className='col-md-4' style={{textAlign:'center', fontStyle:'italic', cursor:'pointer'}} onClick={()=>selectLeague('3') } ><img src={rookie} alt='rookie race selection' style={{width:'220px'}} /> <br/><span style={{fontSize:'.8em'}}>20 Racers</span><br/><span style={{fontSize:'.7em'}}>({(weekInfo.weekinfo.sharkweek === "1" ? "Rookie and Veteran Coaches" : "Rookie Coaches Only") })</span></div>
            <div className='col-md-4' style={{opacity:'40%', textAlign:'center', fontStyle:'italic'}} onClick={()=>selectLeague('2') } disabled><img src={vet} alt='vet race selection' style={{width:'220px'}} /><br/><span style={{fontSize:'.8em'}}>COMING SOON</span><br/><span style={{fontSize:'.7em'}}>(Veteran Coaches Only)</span> </div>
            <div className='col-md-4' style={{textAlign:'center', fontStyle:'italic', cursor:'pointer'}} onClick={()=>selectLeague('1') }><img src={elite} alt='elite race selection' style={{width:'220px'}} /> <br/><span style={{fontSize:'.8em'}}>20 + Racers</span><br/><span style={{fontSize:'.7em'}}>(Elite & Legendary Coaches Only)</span></div>
        </div>
        <div className='col-md-12' id='selectCoachid' style={{display:(regSelection === 'coach' ? 'inline' : 'none')}}>
            <NFTGridCoachSelectable nftArray={coachArray} nftType={'coach'} maxSel={1} setSelectedItems={setSelectedCoach} selectedItems={selectedCoach.id}/>
                    </div>
                    <div className='col-md-12' id='selectRacers' style={{display:(regSelection === 'racers' ? 'block' : 'none')}}>
                    <RacesList collectionslist={racerArray} weekInfo={weekInfo} setSelectedItems={setSelectedRacers} selectedItems={selectedRacers} league={regInfo.league} hilo={(regInfo.league === "1" ? accountDetails.hilo : accountDetails.hilorookie)} walletAddress={walletAddress} currdivision={(regInfo.league === "1" ? accountDetails.elitediv : accountDetails.vetdiv)} updateHiLoStatus={updateHiLoStatus} currentSelManageStyle={currentSelManageStyle} setCurrentSelManageStyle={setCurrentSelManageStyle} selectedManagement={selectedManagement} setSelectedManagement={setSelectedManagement} />
                    <div className='col-md-12 createFormatAmountDue row'  style={{marginTop:'20px', paddingLeft:'20px', paddingRight:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginRight:'10px', display:(weekInfo.weekinfo.regatta === "0" && weekInfo.weekinfo.sharkweek === "0" ? 'flex' : 'none')}}><div className='col-md-6'>Price per racer: <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> {(regInfo.league === "1" ? maticEliteCost : (regInfo.league === "2" ? maticVetCost : maticRookieCost)) }  <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> {(regInfo.league === "1" ? pearlEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlRookieCost))}</div><div className='col-md-6' style={{textAlign:'right'}}> Total: ({selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length} racers) <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/>{(selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length * parseFloat((regInfo.league === "1" ? maticEliteCost : (regInfo.league === "2" ? maticVetCost : maticRookieCost)))).toFixed(2)} <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/>{selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length * parseInt((regInfo.league === "1" ? pearlEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlRookieCost)))} </div></div>
                    <div className='col-md-12 createFormatAmountDue row'  style={{marginTop:'20px', paddingLeft:'20px', paddingRight:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginRight:'10px', display:(weekInfo.weekinfo.regatta === "1" ? 'flex' : 'none')}}><div className='col-md-6'>Price per team: <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> { (regInfo.league === "1" ? maticRegattaTeamEliteCost : maticRegattaTeamRookCost) }  <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> {(regInfo.league === "1" ? pearlRegattaTeamEliteCost : pearlRegattaTeamRookCost)}</div><div className='col-md-6' style={{textAlign:'right'}}> Total: ({selectedRacers.filter(x => x.registered === "no").length} racers) <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> </div></div>
                    <div className='col-md-12 createFormatAmountDue row'  style={{marginTop:'20px', paddingLeft:'20px', paddingRight:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginRight:'10px', display:(weekInfo.weekinfo.sharkweek === "1"  ? 'flex' : 'none')}}><div className='col-md-12'>Price per racer: <span style={{fontWeight:'bold'}}>Tier 1:</span> <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> {(regInfo.league === "1" ? maticSharkTOneEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTOneRookCost)) }  <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> {(regInfo.league === "1" ? pearlSharkTOneEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTOneRookCost))} <span style={{fontWeight:'bold'}}>Tier 2:</span> <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> {(regInfo.league === "1" ? maticSharkTTwoEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTTwoRookCost)) }  <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> {(regInfo.league === "1" ? pearlSharkTTwoEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTTwoRookCost))} <span style={{fontWeight:'bold'}}>Tier 3:</span> <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/> {(regInfo.league === "1" ? maticSharkTThreeEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTThreeRookCost)) }  <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/> {(regInfo.league === "1" ? pearlSharkTThreeEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTThreeRookCost))}</div><div className='col-md-6' style={{textAlign:'right'}}> Total: ({selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length} racers) <img src={maticimg} alt={'matic logo'} style={{width:'25px', margin:'4px'}}/>{((selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("1")).length * parseFloat((regInfo.league === "1" ? maticSharkTOneEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTOneRookCost)))) + (selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("2")).length * parseFloat((regInfo.league === "1" ? maticSharkTTwoEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTTwoRookCost)))) + (selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("3")).length * parseFloat((regInfo.league === "1" ? maticSharkTThreeEliteCost : (regInfo.league === "2" ? maticVetCost : maticSharkTThreeRookCost))))).toFixed(2)} <img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/>{(selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("1")).length * parseInt((regInfo.league === "1" ? pearlSharkTOneEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTOneRookCost)))) + (selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("2")).length * parseInt((regInfo.league === "1" ? pearlSharkTTwoEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTTwoRookCost)))) + (selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league && x.tier.includes("3")).length * parseInt((regInfo.league === "1" ? pearlSharkTThreeEliteCost : (regInfo.league === "2" ? pearlVetCost : pearlSharkTThreeRookCost))))} </div></div>
                    <div className='col-md-12 createFormatAmountDue row'  style={{marginTop:'20px', paddingLeft:'20px', paddingRight:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginRight:'10px'}}><div className='col-md-6'>Currently Registered: </div><div className='col-md-6' style={{textAlign:'right'}}> {racerArray.filter(x => x.registered === "yes" && parseInt(x.league) === parseInt(regInfo.league)).length} racers</div></div>
                    <div className='col-md-12 createFormatAmountDue row'  style={{marginTop:'20px', paddingLeft:'20px', paddingRight:'10px', backgroundColor: 'rgba(0, 0, 0, 0.2)', marginRight:'10px', display:(regInfo.league  !== "3"  ? 'flex' : 'none')}}><div className='col-md-6'>Hydrolyte: <img src={hydroimg} alt={'hydro logo'} style={{width:'25px', margin:'4px'}}/></div><div className='col-md-6' style={{textAlign:'right'}}> Earned: <span style={{fontWeight:'bold'}}>{getHydrolyteByRacerReg(racerArray.filter(x => x.registered === "yes" && parseInt(x.league) === parseInt(regInfo.league)).length + selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length).currhydro}</span>. Register <span style={{fontWeight:'bold'}}>{getHydrolyteByRacerReg(racerArray.filter(x => x.registered === "yes" && parseInt(x.league) === parseInt(regInfo.league)).length + selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length).nexttier}</span> more racers to earn <span style={{fontWeight:'bold'}}>{getHydrolyteByRacerReg(racerArray.filter(x => x.registered === "yes" && parseInt(x.league) === parseInt(regInfo.league)).length + selectedRacers.filter(x => x.registered === "no" && x.league === regInfo.league).length).nexthydro}</span> more.</div></div>
                    </div>
                    <div className='col-md-12' id='confirmReg' style={{display:(regSelection === 'confirm' ? 'block' : 'none')}}>
                        <div className='col-md-12 createFormat row' style={{marginTop:'20px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px'}}><div className='col-md-6'><span style={{fontSize:'.9em'}}>Congratulations</span><div style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', fontWeight:'bold'}}>{(regInfo.league === "1" ? accountName.eliteName : (regInfo.league === "2" ? accountName.vetName : accountName.rookName))}</div><span style={{fontSize:'.9em'}}>Is successfully registered</span></div><div className='col-md-4 row' style={{fontSize:'.8em'}}><div className='col-md-6'>The Reef:</div><div className='col-md-6' style={{fontWeight:'bold'}}>{(regInfo.league === undefined ? '' : (regInfo.league === "1" ? "Elite" : (regInfo.league === "2" ? "Veteran" : "Rookie")))} League</div><div className='col-md-6'>Week #:</div><div className='col-md-6' style={{fontWeight:'bold'}}>{currWeekDisp}</div><div className='col-md-6'>Date:</div><div className='col-md-6' style={{fontWeight:'bold'}}>{todaysDate}</div></div><div className='col-md-2'><img src={(regInfo.league === "1" ? elite :(regInfo.league === "2" ? vet : rookie))} alt='race selection' style={{width:'100px'}} /> </div></div>
                        <div className='col-md-12 createFormat row' style={{marginTop:'20px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px'}}>
                            <div className='col-md-3'>
                        <div className="col" style={{maxWidth:'120px'}}>
            <div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)'}}>
                    <img src={selectedCoach.image} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={selectedCoach.image}  />
            </div>
                <div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
                    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{selectedCoach.collection} #{selectedCoach.id} </p>
                    <p style={{textAlign:'center', marginBottom:'5px'}}>{(selectedCoach.levelarr !== undefined ? selectedCoach.levelarr.map(function(lvl, x){return <img src={star} alt="ranks" style={{width:'25px', paddingLeft:'2px', paddingRight:'2px'}} key={x} />}) : '')}</p>
                    <p style={{textAlign:'center',}}><span style={{color:'black', fontSize:'.8em'}}>Reef Points: {selectedCoach.reefpoints}</span></p>
                </div>
            </div>
                            
                            </div>
<div className='col-md-3' style={{paddingTop:'10px'}}><p>Coach:</p><div>{(selectedCoach.baseboostshrt !== undefined ? selectedCoach.baseboostshrt : '')}</div><div>{(selectedCoach.legboostshrt !== undefined ? selectedCoach.legboostshrt  : '')}</div>
<div>{(selectedCoach.skinboostshrt !== undefined ? selectedCoach.skinboostshrt : '')}</div><div>{(selectedCoach.ttboostshrt !== undefined ? selectedCoach.ttboostshrt : '')}</div>
<div>{(selectedCoach.oceanboostshrt !== undefined ? selectedCoach.oceanboostshrt  : '')}</div>
<div>{(selectedCoach.hemiboostshrt !== undefined ? selectedCoach.hemiboostshrt : '')}</div>
<div>{(selectedCoach.tfboostshrt !== undefined ? selectedCoach.tfboostshrt : '')}</div>

</div>
<div className='col-2' style={{paddingTop:'10px', minWidth:'120px'}}><div>Racers:</div>
<div style={{paddingTop:'10px', color:'rgba(227, 81, 185, 1)', display:(weekInfo.weekinfo.regatta === "1" || weekInfo.weekinfo.sharkweek === "1"  ? 'none' : "block")}}>TOTW:</div>
<div style={{paddingTop:'10px', color:'rgba(238, 47, 47, 1)', display:(weekInfo.weekinfo.regatta === "1" ? 'none' : "block")}}>{(weekInfo.weekinfo.sharkweek === "1" ? "Tier 3" : "Tiers")}:</div>
<div style={{paddingTop:'10px', color:'rgba(229, 169, 26, 1)'}}>{(weekInfo.weekinfo.regatta === "1" ? 'Alternate' : (weekInfo.weekinfo.sharkweek === "1" ? "Tier 2" : "Hi-Lo"))}:</div>
<div style={{paddingTop:'10px', color:'rgba(218, 229, 26, 1)'}}>{(weekInfo.weekinfo.regatta === "1" ? 'Regatta' : (weekInfo.weekinfo.sharkweek === "1" ? "Tier 1" : "FFA"))}:</div>
</div>
<div className='col-1' style={{paddingTop:'10px'}}><div><span style={{fontWeight:'bold'}}>({stakedRacers.filter(x => parseInt(x.league) === parseInt(regInfo.league) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length})</span></div>
<div style={{paddingTop:'10px', display:(weekInfo.weekinfo.regatta === "1" || weekInfo.weekinfo.sharkweek === "1" ? 'none' : "block")}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 22 && parseInt(x.league) === parseInt(regInfo.league) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'10px', display:(weekInfo.weekinfo.regatta === "1" ? 'none' : "block")}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) > 1 && parseInt(x.eventWanted) < 22 && parseInt(x.league) === parseInt(regInfo.league) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'10px'}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 1 && parseInt(x.league) === parseInt(regInfo.league) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'10px'}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 0 && parseInt(x.league) === parseInt(regInfo.league) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
    </div> 
    <div className='col-2' style={{paddingTop:'10px', minWidth:'120px'}}><div>Speed:</div>
<div style={{paddingTop:'10px'}}>Average:</div>
<div style={{paddingTop:'10px'}}>Highest:</div>
<div style={{paddingTop:'10px'}}>Lowest:</div>
</div>
<div className='col-1' style={{paddingTop:'10px'}}><div><span style={{fontWeight:'bold'}}></span></div>
<div style={{marginTop:'33px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.average}</span></div>
<div style={{paddingTop:'10px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.highest}</span></div>
<div style={{paddingTop:'10px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.lowest}</span></div>
    </div>                
                            </div>
                            <div className='col-md-12' style={{textAlign:'center'}}>Go to 'Management' to set team roles</div>
                    </div>
                    <div style={{textAlign:'center',marginBottom:'20px', height:'40px'}}><button id="coachselButton" type="button" style={{marginRight:'5%',width:'160px', display:(Object.keys(selectedCoach).length === 0 || regSelection !== 'coach' ? 'none' : 'inline-block')}} className='btn btn-primary' onClick={() => selectCoach()}><span>Next</span></button></div>
                    <div style={{textAlign:'center',marginBottom:'20px', height:'40px'}}><button id="teamsubmitButton" type="button" style={{marginRight:'5%',width:'160px', display:(selectedRacers.filter(x => x.registered === "no").length === 0 || regSelection !== 'racers' ? 'none' : 'inline-block' ),backgroundColor:'#37780E', color:'white'}} className='btn' onClick={() => submitTeam()}><span>Submit Team</span></button></div>
                    
        </div>
        }
    }else if (menuSelection === 'management'){
    if (walletAddress === ''){
            return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access management.</div>)
    }else{  
        const changeCoachSel = (x) => {
            setCoachChange("yes");
            console.log(selectedCoach);
            console.log(Object.keys(selectedCoach).length);
            if (selectedCoach !== registeredCoach){
                setSelectedCoach(registeredCoach);
            }
            
        }

        const cancelCoachUp = () => {
            setCoachChange("no");
            if (selectedCoach !== registeredCoach){
                setSelectedCoach(registeredCoach);
            }
        }

        const setManageStyle = (e) => {
            setSelectedManagement(e);
        }

       const updateManageStyleSel = async(x) => {

            var myCreateModal = new Modal(document.getElementById('showAlerts'));
            myCreateModal.show();

                setModalInfo({"message":"Waiting on Management Style submission.", "type":"setmanagestyle" });
                    const manageResults = await setLeagueManagement(regInfo.league,parseInt(selectedManagement));
                    if (manageResults !== undefined){
                        if (manageResults !== undefined){
                            if (manageResults.blockNumber !== '' && manageResults.blockNumber !== undefined){
                                setModalInfo({"message":"Management Style Set.", "type":"managestyleset" });
                                    let tmpManage = currentSelManageStyle;
                                    tmpManage[leagueToManage] = selectedManagement;
                                    setCurrentSelManageStyle(tmpManage);
                            }else {
                                setModalInfo({"message":'Issue connecting to the blockchain. Please try again. League:' + regInfo.league + ' Coach:' + selectedCoach.id + ' message:' + manageResults.message,"type":'error'});
                                return false;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return false;
        
                        }
                    }


    //        }
            
        }



        const updateManageCoach = async() => {
         /*   if (Object.keys(selectedCoach).length === 0){
                const coachNotSel = window.confirm('You have not selected a coach. Are you sure you want to continue?');
                if (!coachNotSel){
                    return false;
                }
            }*/
            var myCreateModal = new Modal(document.getElementById('showAlerts'));
            myCreateModal.show();
           


                
                if (regInfo.selectedCoach !== coachRegArray[regInfo.league] ) {
                    setModalInfo({"message":"Waiting on Coach submission.", "type":"registerteam" });
 
                    const coachResults = await setLeagueCoach(leagueToManage, selectedCoach.id);
                    if (coachResults !== undefined){
                        if (coachResults !== undefined){
                            if (coachResults.blockNumber !== '' && coachResults.blockNumber !== undefined){
                                setModalInfo({"message":"Coach change successful.", "type":"teamregistered" });
                                setRegCoach(selectedCoach);
                                getConfirmStats(regInfo.league, [])
                            }else {
                                setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                                return;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return;
        
                        }
                    }

                }
            
        }

        const goToManage = (x) => {
            selectManageSection(x);
        }

        const selectRole = async(racer, role) => {
            let roles = {...currentRoles};
                racer.pending = "yes"
                racer.roleName = "";
                racer.roleBoost = 0;
            if (roles.cap.id === racer.id){
                roles.cap = {};
                
            //    racer.speedTotal = racer.speedTotal - 3;
            }
            if (roles.anc.id === racer.id){
                roles.anc = {};
            //    racer.speedTotal = racer.speedTotal - 4;
            }
            if (roles.ass.id === racer.id){
                roles.ass = {};
            //    racer.speedTotal = racer.speedTotal - 1;
            }
            if (roles.equ.id === racer.id){
                roles.equ = {};
            //    racer.speedTotal = racer.speedTotal + 2;
            }
            if (roles.ben.id === racer.id){
                roles.ben = {};
            //    racer.speedTotal = racer.speedTotal + 1;
            }
            let localhilo = (regInfo.league === "1" ? accountDetails.hilo : accountDetails.hilorookie);
            if (role === "Captain"){
                if (weekInfo.weekinfo.regatta === "1"){
                if (localhilo === 'hi'){
                    racer.roleBoost = 3;
                }else{
                    racer.roleBoost = -3;
                }
            }else{
                racer.roleBoost = 3;
            }
                racer.roleName = "Captain";
            //    racer.speedTotal = racer.speedTotal + racer.roleBoost  + (weekInfo.weekinfo.regatta === "0" ? racer.bNum : (localhilo === 'hi' || racer.raceid === 1 ? racer.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? racer.wBoostB : (localhilo === 'hi' || racer.raceid === 1  ? racer.wBoostBHi: racer.wBoostBLo));
                roles.cap = racer;
            }else if (role === "Anchor"){
                racer.roleName = "Anchor";
                racer.roleBoost = 4;
            //    racer.speedTotal = racer.speedTotal + racer.roleBoost  + (weekInfo.weekinfo.regatta === "0" ? racer.bNum : (localhilo === 'hi' || racer.raceid === 1 ? racer.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? racer.wBoostB : (localhilo === 'hi' || racer.raceid === 1  ? racer.wBoostBHi: racer.wBoostBLo));
                roles.anc = racer;
            }else if (role === "Assistant"){
                racer.roleName = "Assistant Captain";
                racer.roleBoost = 1;
            //    racer.speedTotal = racer.speedTotal + racer.roleBoost  + (weekInfo.weekinfo.regatta === "0" ? racer.bNum : (localhilo === 'hi' || racer.raceid === 1 ? racer.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? racer.wBoostB : (localhilo === 'hi' || racer.raceid === 1  ? racer.wBoostBHi: racer.wBoostBLo));
                roles.ass = racer;
            }else if (role === "Equipment"){
                racer.roleName = "Equipment Manager";
                racer.roleBoost = -2;
            //    racer.speedTotal = racer.speedTotal + racer.roleBoost  + (weekInfo.weekinfo.regatta === "0" ? racer.bNum : (localhilo === 'hi' || racer.raceid === 1 ? racer.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? racer.wBoostB : (localhilo === 'hi' || racer.raceid === 1  ? racer.wBoostBHi: racer.wBoostBLo));
                roles.equ = racer;
            }else if (role === "Bench"){
                racer.roleName = "Bench Warmer";
                racer.roleBoost = -1;
            //    racer.speedTotal = racer.speedTotal + racer.roleBoost  + (weekInfo.weekinfo.regatta === "0" ? racer.bNum : (localhilo === 'hi' || racer.raceid === 1 ? racer.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? racer.wBoostB : (localhilo === 'hi' || racer.raceid === 1  ? racer.wBoostBHi: racer.wBoostBLo));
                roles.ben = racer;
            }

            setCurrentRoles(roles);
            setPendingRoleChanges("yes");
        }
        
        const submitRoles = async() => {
            
            let rolesArray = [];
            let rolesIDArray = [];
            let rolesContractArray = [];
            let pearlTotal = 0;
            for(const role in currentRoles){

                if (currentRoles[role] !== undefined && Object.keys(currentRoles[role]).length > 0 && currentRoles[role].pending === "yes") {
                    let roleid = 0;
                    if (currentRoles[role].roleName === "Anchor"){
                        roleid = 1;
                        pearlTotal += 250;
                    }else if (currentRoles[role].roleName === "Assistant Captain"){
                        roleid = 2;
                        pearlTotal += 100;
                    }else if (currentRoles[role].roleName === "Bench Warmer"){
                        roleid = 4;
                        pearlTotal += 100;
                    }else if (currentRoles[role].roleName === "Equipment Manager"){
                        roleid = 3;
                        pearlTotal += 200;
                    }else if (currentRoles[role].roleName === "Captain"){
                        roleid = 5;
                    }
                        rolesArray.push(roleid);
                        rolesIDArray.push(currentRoles[role].id);
                        rolesContractArray.push(currentRoles[role].contract);
                } else {
                    rolesArray.push(0);
                    rolesIDArray.push(0);
                    rolesContractArray.push("0x0000000000000000000000000000000000000000");
                }
            
            }

            var myCreateModal = new Modal(document.getElementById('showAlerts'));
            myCreateModal.show();
            setModalInfo({"message":"Waiting on role submission.", "type":"setroles" });
 
                    const roleResults = await setRoles(rolesIDArray, rolesContractArray, rolesArray, leagueToManage, walletAddress, pearlTotal);
                    if (roleResults !== undefined){

                        if (roleResults !== undefined){
                            if (roleResults.blockNumber !== '' && roleResults.blockNumber !== undefined){
                                setModalInfo({"message":"Roles set successfully", "type":"roleset" });
                                await loadCollections(selectedCoach.id, true);
                                getConfirmStats(regInfo.league, []);
                                setRoleSelItems([]);
                                setPendingRoleChanges("no");
                            }else {
                                setModalInfo({"message":'Issue connecting to the blockchain. Please try again. ' + roleResults ,"type":'error'});
                                return;
                            }
                        }else {
                            setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                            return;
        
                        }
                    }

        }

        const cancelRoleChng = () => {
            setCurrentRoles(prevSetRoles);
            setRoleSelItems([]);
            setPendingRoleChanges("no");
        }

        

        const submitChanges = async() => {
            let tempHydroChanges = [...pendingHydroRacers];
                let racersfound = 0;
                let racersArray = [];
                let contractArray = [];
                let hydroArray = [];
                let tempMoveTo = moveTo;
                 for (let x = 0; x < tempHydroChanges.length; x++){

                    
                    if (tempHydroChanges[x].pendinghydro !== 0){
                        racersArray.push(tempHydroChanges[x].id);
                        contractArray.push(tempHydroChanges[x].contract);
                        hydroArray.push(tempHydroChanges[x].pendinghydro);
                        racersfound +=1;
                    }
            }   

            if (selectChanges.length > 0 || racersfound > 0){

                
                console.log(tempMoveTo);
                if ((tempMoveTo === "" || tempMoveTo === "99")  && racersfound === 0){
                    alert("You must select a race type to move to or assign Hydrolyte.");
                    return false;

                }
                var myCreateModal;
                console.log(tempMoveTo.length);

                if (tempMoveTo !== "99" && tempMoveTo !== ""){
                myCreateModal = new Modal(document.getElementById('showAlerts'));
                myCreateModal.show();
                setModalInfo({"message":"Preparing to move racers.", "type":"move" });
     
                        const moveResults = await moveRacers(selectChanges, moveTo);
                            if (moveResults !== undefined){
                                if (moveResults.blockNumber !== '' && moveResults.blockNumber !== undefined){
                                    setModalInfo({"message":"Racers moved successfully.", "type":"movecomp" });
                                    const newlyStaked = await getStakedRacers();
                                    setCurrStakedRacers(newlyStaked);
                                    getConfirmStats(regInfo.league, newlyStaked);
                                    setSelectChanges([]);
                                    setChangeSelItems([]);

                                }else {
                                    if (moveResults === 'EventSwitchNA'){
                                            setModalInfo({"message":'Moving to a different event is currently not allowed.',"type":'info'});
                                    } else if (moveResults === 'StakedMoreThanMax'){
                                    setModalInfo({"message":'This event is currently at max registration.',"type":'info'});
                                        }else{
                                        setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                                    }
                                    
                                    
                                }
                                return false;
                            }else {
                                setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                                return;
            
                            }
                }

                if (racersfound > 0){
                    myCreateModal = new Modal(document.getElementById('showAlerts'));
                myCreateModal.show();
                setModalInfo({"message":"Preparing to adjust hydrolyte.", "type":"sethydrolyte" });
     
                        const hydroResults = await assignHydro(racersArray, contractArray, hydroArray, leagueToManage);
                            if (hydroResults !== undefined){
                                if (hydroResults.blockNumber !== '' && hydroResults.blockNumber !== undefined){
                                    setModalInfo({"message":"Hydrolyte adjusted successfully.", "type":"hydrolyteset" });
                                    const newlyStaked = await getStakedRacers();
                                    setCurrStakedRacers(newlyStaked);
                                    getConfirmStats(regInfo.league, newlyStaked);
                                    setSelectChanges([]);
                                    setChangeSelItems([]);
                                    setPendingHydro(0);
                                    setPendingHydroRacers([]);
                                }else {
                                    if (hydroResults === 'EventSwitchNA'){
                                            setModalInfo({"message":'Moving to a different event is currently not allowed.',"type":'info'});
                                    }else{
                                        setModalInfo({"message":'Issue connecting to the blockchain. Please try again.',"type":'error'});
                                    }
                                    
                                    
                                }
                                return false;
                            }else {
                                setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                                return;
            
                            }
                }
                
                        

            }else{
                return false;
            }
        }

        const cancelChanges = async () => {
            setSelectChanges([]);
            setChangeSelItems([]);
            setPendingHydroRacers([]);
            setPendingHydro(0);
            const earnedHydro = await getStoredHydro(walletAddress);
            let tempEarnedHydro = [0,parseInt(earnedHydro[1]),parseInt(earnedHydro[2])];
            setLeagueHydro(tempEarnedHydro);
        }

        const unRegisterRacers = async() => {
            if (selectChanges.length > 0){
                let tempHydroChanges = [...racerArray];
                let unregisterhydro = 0;
                let racersfound = 0;
                let hydroIds = "";

            for (let x = 0; x < tempHydroChanges.length; x++){
                if (racersfound === changesSelItems.length){
                    break;
                }
                if (changesSelItems.includes(tempHydroChanges[x].id + tempHydroChanges[x].contract)){
                
                        unregisterhydro += tempHydroChanges[x].hydro;
 			            racersfound +=1;
                         if (hydroIds === ""){
                            hydroIds += tempHydroChanges[x].id;
                        }else{
                            hydroIds += ", " + tempHydroChanges[x].id ;
                        }
                }
           
            }

            if (unregisterhydro > 0) {
                alert('The following racers have Hydrolyte assigned (' + hydroIds + '). Please remove before you unregister them.')
                return false;
            }
              

                var myCreateModal = new Modal(document.getElementById('showAlerts'));
                myCreateModal.show();
                setModalInfo({"message":"Waiting on Unregister.", "type":"unreg" });
                        const unregResults = await unstakeRacers(selectChanges);
                        
                            if (unregResults !== undefined){
                                if (unregResults.blockNumber !== '' && unregResults.blockNumber !== undefined){
                                    setModalInfo({"message":"Racers unregistered successfully.", "type":"unregconfirm" });
                                    const newlyStaked = await getStakedRacers();
                                    setCurrStakedRacers(newlyStaked);
                                    getConfirmStats(regInfo.league, newlyStaked);
                                    setSelectChanges([]);
                                }else {
                                    setModalInfo({"message":'Issue connecting to the blockchain. Please try again.' + unregResults,"type":'error'});
                                    return;
                                }
                            }else {
                                setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                                return;
            
                            }
                        
    
            }else{
                return false;    
            }
        }

        const spinMystery = async(type) => {
            alert('Mystery Buff coming soon');
        }

        
    const leagueNameChange = () => {
        let showChangeTemp = [...showChange];
        showChangeTemp[leagueToManage] = !showChangeTemp[leagueToManage]
        setShowChange(showChangeTemp);
    }

//    const abbChange = () => {
//        setShowAbbChange(!showAbbChange);
//    }

    const cancelLeagueNameChange = () => {
        accForChange.current.value = (leagueToManage === "1" ? accountName.eliteName : (leagueToManage === "2" ? accountName.vetName : accountName.rookName));
        let showChangeTemp = [...showChange];
        showChangeTemp[leagueToManage] = false
        setShowChange(showChangeTemp);
        setMessage("");
    }

        const updateLeagueName = async () => {

            if (leagueToManage === "" || leagueToManage === undefined){
                setMessage('Error trying to update league name.');
                return false;
            }
            
            let tempIncName = (leagueToManage === "1" ? accountName.eliteName : (leagueToManage === "2" ? accountName.vetName : accountName.rookName));
            if (accForChange.current.value === tempIncName){
                alert('League name was not changed');
                return false;
            }
            if (accForChange.current.value === ''){
                alert('League name cannot be blank.');
            }else{
                setMessage("");
                var myNameModal = new Modal(document.getElementById('showAlerts'));
                setModalInfo({"message":'Waiting on league name update.',"type":'accstart'})
                myNameModal.show();
                const updateResp = await updateName(walletAddress, accForChange.current.value, leagueToManage);
                if (updateResp !== undefined){
                    if (updateResp.blockNumber !== '' && updateResp.blockNumber !== undefined){
                        
                        setModalInfo({"message":"League name updated.", "type":"accupdated" });
                        setName(accForChange.current.value, '', walletAddress, leagueToManage);
                        let tempACCName = {...accountName};
                        if (leagueToManage === "1")     {
                            tempACCName.eliteName = accForChange.current.value;
                        } else if (leagueToManage === "2") {
                            tempACCName.vetName = accForChange.current.value;
                        } else if (leagueToManage === "3"){
                            tempACCName.rookName = accForChange.current.value;
                        }
                        setAccountName(tempACCName);
                        let showChangeTemp = [...showChange];
                        showChangeTemp[leagueToManage] = false
                        setShowChange(showChangeTemp);
                        
                    }else {
                        setModalInfo({"message":'Issue connecting to the blockchain. Please try again. ' + updateResp,"type":'error'});
                        return false;
                    }
                 } else {
                        setModalInfo({"message":'User has rejected the transaction.',"type":'error'});
                        return false;
                 }
            }
        }

        const increaseEndurance = async() => {

            let tooMuchHydro = false;
            let maxHydroMet = false;
            let tooMuchHydroIds = "";
            let maxHydroIds = "";
            let totalHydroAssigned = 0;
            let tempHydroChanges = [...racerArray];
            let tempHydroRacers = [...pendingHydroRacers];
            let racersfound = 0;
            

            if (changesSelItems.length === 0 ){
                alert('You must select some racers to add Hydrolyte.')
                return false;
            }
            if (parseInt(leagueHydro[leagueToManage]) === 0){
                alert('You cannot increase Hydrolyte as you currently have 0.')
                return false;
            }

            if (weekInfo.weekinfo.season_week === "5"){
                alert('You cannot use Hydrolyte during playoffs.')
                return false;
            }

            for (let x = 0; x < tempHydroChanges.length; x++){
                if (racersfound === changesSelItems.length){
                    break;
                }
                if (changesSelItems.includes(tempHydroChanges[x].id + tempHydroChanges[x].contract)){

                    if (totalHydroAssigned < leagueHydro[leagueToManage]){

                        let foundhydroracer = false;
                        for (let y = 0; y < tempHydroRacers.length; y++){
                            if (parseInt(tempHydroChanges[x].id) === parseInt(tempHydroRacers[y].id) && tempHydroChanges[x].contract === tempHydroRacers[y].contract){
                            if ((parseInt(tempHydroChanges[x].hydro) + parseInt(tempHydroRacers[y].pendinghydro)) >= 5 ){
                                if (tooMuchHydroIds === ""){
                                    tooMuchHydroIds += tempHydroChanges[x].id;
                                }else{
                                    tooMuchHydroIds += ", " + tempHydroChanges[x].id ;
                                }
                                    tooMuchHydro = true;
                                } else {
                                    tempHydroRacers[y].pendinghydro +=1;
                                    totalHydroAssigned +=1;

                                }
                                    foundhydroracer = true;
                                    break;
                            }
                        }

                        if (!foundhydroracer){
                            let newracer = {}
                            newracer.id = tempHydroChanges[x].id;
                            newracer.contract = tempHydroChanges[x].contract;
                            newracer.pendinghydro =1;
                            totalHydroAssigned +=1;
                            tempHydroRacers.push(newracer);
                        }
                        

                    }else{
                        if (maxHydroIds === ""){
                            maxHydroIds += tempHydroChanges[x].id;
                        }else{
                            maxHydroIds += ", " + tempHydroChanges[x].id ;
                        }
                        maxHydroMet = true;
                    

                }
            racersfound +=1;
            }
            }   

            if (totalHydroAssigned > 0){
            //    setRacerArray(tempHydroChanges);
                let tempLeagueHydro = [...leagueHydro];
                tempLeagueHydro[leagueToManage] = parseInt(tempLeagueHydro[leagueToManage]) - parseInt(totalHydroAssigned);
                setLeagueHydro(tempLeagueHydro); 
                let tempPending = pendingHydro;
                setPendingHydro(tempPending - totalHydroAssigned);
                console.log(tempHydroRacers);
                setPendingHydroRacers(tempHydroRacers);
            }

            if (tooMuchHydro){
                alert('You cannot increase Hydrolyte on ' + tooMuchHydroIds + '. They have max Hydrolyte assigned.')
                return false;
            }
            if (maxHydroMet){
                alert('You cannot increase Hydrolyte on ' + maxHydroIds + '. Their is no more Hydrolyte to assign.')
                return false;
            }
            
            
        }

        const decreaseEndurance = async() => {
            let noHydroAssigned = false;
            let noHydroIds = "";
            let tempHydroChanges = [...racerArray];
            let tempHydroRacers = [...pendingHydroRacers];
            let totalHydroUnAssigned = 0;
            let racersfound = 0;
            let foundRacers = [];

            if (changesSelItems.length === 0 ){
                alert('You must select some racers to remove Hydrolyte.')
                return false;
            }

            for (let x = 0; x < tempHydroChanges.length; x++){
                if (racersfound === changesSelItems.length){
                    break;
                }
                if (changesSelItems.includes(tempHydroChanges[x].id + tempHydroChanges[x].contract)){

                        let foundhydroracer = false;
                        for (let y = 0; y < tempHydroRacers.length; y++){
                            if (parseInt(tempHydroChanges[x].id) === parseInt(tempHydroRacers[y].id) && tempHydroChanges[x].contract === tempHydroRacers[y].contract && changesSelItems.includes(tempHydroRacers[y].id + tempHydroRacers[y].contract)){

                                if ((tempHydroChanges[x].hydro + tempHydroRacers[y].pendinghydro)  < 1 ){
                                    console.log('found no hydro');
                                if (noHydroIds === ""){
                                    noHydroIds += tempHydroChanges[x].id;
                                }else{
                                    noHydroIds += ", " + tempHydroChanges[x].id ;
                                }
                                noHydroAssigned = true;
                                
                                } else {
                                tempHydroRacers[y].pendinghydro -=1;
                                totalHydroUnAssigned += 1;
                                
                                
                            }
                            foundRacers.push(y);
                            foundhydroracer = true;
                            break;
                        }


                /*        if (!foundhydroracer && tempHydroChanges[x].hydro > 0 ){
                            let newracer = {}
                            newracer.id = tempHydroChanges[x].id;
                            newracer.contract = tempHydroChanges[x].contract;
                            newracer.pendinghydro = -1;
                            totalHydroUnAssigned += 1;
                            tempHydroRacers.push(newracer);
                        }else{
                            if (!foundhydroracer && !foundRacers.includes(y)){
                                console.log('not found no hydro');
                                if (noHydroIds === ""){
                                    noHydroIds += tempHydroChanges[x].id;
                                }else{
                                    noHydroIds += ", " + tempHydroChanges[x].id ;
                                }
                                noHydroAssigned = true;
                                foundRacers.push(y);
                            }
                        }*/
                    

            }

            if (!foundhydroracer && tempHydroChanges[x].hydro > 0 ){
                            let newracer = {}
                            newracer.id = tempHydroChanges[x].id;
                            newracer.contract = tempHydroChanges[x].contract;
                            newracer.pendinghydro = -1;
                            totalHydroUnAssigned += 1;
                            tempHydroRacers.push(newracer);
            }else{
                            if (!foundhydroracer){
                                if (noHydroIds === ""){
                                    noHydroIds += tempHydroChanges[x].id;
                                }else{
                                    noHydroIds += ", " + tempHydroChanges[x].id ;
                                }
                                noHydroAssigned = true;
                            }
                        }
                            

        racersfound +=1;  
                }  
        }


            
            if (totalHydroUnAssigned !== 0){
            //    setRacerArray(tempHydroChanges);
                let tempLeagueHydro = [...leagueHydro];
                tempLeagueHydro[leagueToManage] = parseInt(tempLeagueHydro[leagueToManage]) + totalHydroUnAssigned;
                setLeagueHydro(tempLeagueHydro); 
                let tempPending = pendingHydro;
                setPendingHydro(tempPending + totalHydroUnAssigned);
                setPendingHydroRacers(tempHydroRacers);
            }
            if (noHydroAssigned){
                    alert('You cannot decrease Hydrolyte from ' + noHydroIds + '. Their is no Hydrolyte assigned.')
                    
            }
        }

  

        
        if (leagueToManage === ''){
        return <div className='col-md-12' style={{marginTop:'20px', paddingLeft:'40px'}}>Please select a league to manage.</div>
        
        }else if(racerArray.filter(x => parseInt(x.league) === parseInt(leagueToManage) && x.registered === "yes").length === 0){
            return <div className='col-md-12' style={{marginTop:'20px', paddingLeft:'40px'}}>{(leagueToManage === "Select League" ? "Please select league to manage" : "You are currently not registered in the " + (leagueToManage === undefined || leagueToManage === '' ? '' : (leagueToManage === "1" ? "Elite" : (leagueToManage === "2" ? "Veteran" : "Rookie")) + " league."))} </div>
        }else{

        return <div className='col-md-12' id='confirmReg' style={{display:(leagueToManage !== '' ? 'block' : 'none')}}>
        <div className='col-md-12 createFormat row' style={{marginTop:'40px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'overview' ? 'flex' : 'none')}}>
            <div className='col-md-12 row' style={{display:'flex'}}><div className='col-md-3' style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', fontWeight:'bold'}}>Team Name:</div><div style={{marginLeft:'20px', display:(showChange[leagueToManage] ? 'block' : 'none')}}><input id="accountchange" ref={accForChange} defaultValue={(leagueToManage === "1" ? accountName.eliteName : (leagueToManage === "2" ? accountName.vetName : accountName.rookName))} /> <button style={{paddingLeft:'5px', paddingRight:'5px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline', color:'white'}} onClick={() => updateLeagueName()}>Update</button><button style={{paddingLeft:'5px', paddingRight:'5px', background:'none', border:'none', cursor:'pointer', textDecoration:'underline', color:'white'}} onClick={() => cancelLeagueNameChange()}>Cancel</button></div>
            <div className='col-md-6' style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', color: 'gold'}}>{(leagueToManage === "1" ? accountName.eliteName : (leagueToManage === "2" ? accountName.vetName : accountName.rookName))} </div><div className='col-md-3' style={{fontSize:'.9em', marginTop:'5px', marginBottom:'5px'}}><button style={{color:'blue', background:'none', border:'none', paddingRight:'10px', cursor:'pointer', textDecoration:'underline'}} onClick={() => leagueNameChange()}>(change)</button></div></div>
            <div className='col-md-12 row' style={{display:'flex', marginTop:'20px'}}><div className='col-md-3' style={{fontSize:'1.1em', marginBottom:'5px'}}>League: <span style={{fontWeight:'bold'}}>{(leagueToManage === undefined || leagueToManage === '' ? '' : (leagueToManage === "1" ? "Elite" : (leagueToManage === "2" ? "Veteran" : "Rookie")))}</span><div style={{display:'none'}}>{(weekInfo.weekinfo.regatta === "1" ? ((regInfo.league === "1" && accountDetails.hilo === 'lo') || (regInfo.league === "3" && accountDetails.hilorookie === 'lo') ? 'Mode: Lo' : 'Mode: Hi') : '')}</div><div style={{display:(weekInfo.weekinfo.regatta === "1" ? 'flex' : 'none')}}>Hi <label className="switch"><input type="checkbox" onChange={(e) => {updateHiLoStatus(e, leagueToManage)}} checked={((regInfo.league === "1" && accountDetails.hilo === 'hi') || (regInfo.league === "3" && accountDetails.hilorookie === 'hi') ? false : true )} /><span className="slider round"></span></label> Lo</div></div><div className='col-md-3' style={{fontSize:'1.1em'}}>Week #: <span style={{fontWeight:'bold'}}>{currWeekDisp}</span></div><div className='col-3' style={{textAlign:'right'}}>Date: <span style={{fontWeight:'bold'}}>{todaysDate}</span></div> <div className='col-3' style={{textAlign:'right', marginTop:'-30px'}}><img src={(leagueToManage === "1" ? elite :(leagueToManage === "2" ? vet : rookie))} alt='race selection' style={{width:'120px'}} /></div></div>
            
            </div>


        <div className='col-md-12 createFormat row' style={{marginTop:'40px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'roles' ? 'flex' : 'none')}}><div className='col-md-3'><span style={{fontSize:'.9em'}}></span><div style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', fontWeight:'bold'}}>Roles: {(weekInfo.weekinfo.regatta === "1" ? ((regInfo.league === "1" && accountDetails.hilo === 'lo') || (regInfo.league === "3" && accountDetails.hilorookie === 'lo') ? '(Mode: Lo)' : '(Mode: Hi)') : '')}</div></div><div className='col-md-3' style={{fontSize:'1.1em'}}>{(leagueToManage === undefined || leagueToManage === '' ? '' : (leagueToManage === "3" && weekInfo.weekinfo.regatta !== "1" ? " Only Captain is selectable in Rookie League." : (weekInfo.weekinfo.sharkweek === "1" ? "Roles cannot be set for Shark Week." : "")))}</div><div className='col-md-6' style={{textAlign:'right'}}> <button id="rolesubmitButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(pendingRoleChanges === "yes" ? "unset" : "none")}} className='btn' onClick={() => submitRoles()}><span>Apply Roles</span></button><button id="roleCancelButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(pendingRoleChanges === "yes" ? "unset" : "none")}} className='btn' onClick={() => cancelRoleChng()}><span>Cancel Role Changes</span></button></div></div>
        <div className='col-md-12 createFormat row' style={{ paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', paddingTop:'30px', display:(currManagementSel === 'roles' ? 'flex' : 'none')}}>
        <div className='col-md-2'>
        <div className="col" style={{maxWidth:'180px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)',textAlign:'center', fontSize:'.8em', color:'black', fontWeight:'bold'}}>
    <div style={{paddingTop:'6px', paddingBottom:'6px'}}>{(weekInfo.weekinfo.regatta === "1" &&  ((regInfo.league === "1" && accountDetails.hilo === 'lo') || (regInfo.league === "3" && accountDetails.hilorookie === 'lo')) ? 'Anti-Captain (-3)' : 'Captain (+3)')}
            <br/><img src={captainimg} style={{width:'20px', marginLeft:'5px', marginRight:'5px' }} alt="captian role"  /></div>
    <img src={(currentRoles.cap !== undefined && Object.keys(currentRoles.cap).length > 0 ? currentRoles.cap.image : unsetrole)} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={(currentRoles.cap !== undefined && Object.keys(currentRoles.cap).length > 0 ? 'captain image' : 'captain unset')}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{(currentRoles.cap !== undefined && Object.keys(currentRoles.cap).length > 0  ? currentRoles.cap.collection + ' #' + currentRoles.cap.id : 'Not Set')}  </p>
    <p style={{color:'#000',fontWeight:'bold', textAlign:'center',maxWidth:'152px'}}>{(currentRoles.cap !== undefined && Object.keys(currentRoles.cap).length > 0 ? 'S:' + (currentRoles.cap.speedTotal + getManagementStyleBonuses(selectedManagement, 0,0, "speed") + (weekInfo.weekinfo.regatta === "1" && currentRoles.cap.roleName === "Captain" ? ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' ? 3 : -3) : currentRoles.cap.roleBoost)  + (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.bNum : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.cap.raceid === 1 ? currentRoles.cap.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.wBoostB : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.cap.raceid === 1  ? currentRoles.cap.wBoostBHi: currentRoles.cap.wBoostBLo))) + ' A:' + (currentRoles.cap.accelTotal + getManagementStyleBonuses(selectedManagement, currentRoles.cap.accelTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.wBoostA : (accountDetails.hilo === 'hi' || currentRoles.cap.raceId === "1" ? currentRoles.cap.wBoostAHi: currentRoles.cap.wBoostALo))),"accel") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.wBoostA : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.cap.raceid === 1 ? currentRoles.cap.wBoostAHi: currentRoles.cap.wBoostALo))) +  ' E:' + (currentRoles.cap.endurTotal + getManagementStyleBonuses(selectedManagement, currentRoles.cap.endurTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.wBoostE : (accountDetails.hilo === 'hi' || currentRoles.cap.raceId === "1" ? currentRoles.cap.wBoostEHi: currentRoles.cap.wBoostELo))),"endur") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.cap.wBoostE : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.cap.raceid === 1 ? currentRoles.cap.wBoostEHi: currentRoles.cap.wBoostELo))) : '')}</p>
    <p style={{textAlign:'center'}}>{(currentRoles.cap !== undefined && Object.keys(currentRoles.cap).length > 0  ? (currentRoles.cap.pending === "yes" ? "Pending" : "") + (prevSetRoles.cap !== undefined && Object.keys(prevSetRoles.cap).length > 0 && prevSetRoles.cap !== currentRoles.cap ? " replacing " + prevSetRoles.cap.id  : "" ): "")}</p>
</div>
<div style={{textAlign:'center'}}><img src={pearlimg} alt="pearl logo" style={{width:'30px'}} /> 0</div>
</div>
        </div>
        <div className='col-md-2' style={{display:(weekInfo.weekinfo.regatta === "1" &&  ((regInfo.league === "1" && accountDetails.hilo === 'lo') || (regInfo.league === "3" && accountDetails.hilorookie === 'lo')) ? 'none' : 'unset')}}>
        <div className="col" style={{maxWidth:'180px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)',textAlign:'center', fontSize:'.8em', color:'black', fontWeight:'bold'}}>
    <div style={{paddingTop:'6px', paddingBottom:'6px'}}>Asst. Cap. (+1)<br/><img src={asscapimg} style={{width:'20px', marginLeft:'5px', marginRight:'5px'}} alt="assistant role" /></div>
    <img src={(currentRoles.ass !== undefined && Object.keys(currentRoles.ass).length > 0 ? currentRoles.ass.image : unsetrole)} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={(currentRoles.ass !== undefined && Object.keys(currentRoles.ass).length > 0 ? 'assistant image' : 'assistant unset')}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{(currentRoles.ass !== undefined && Object.keys(currentRoles.ass).length > 0  ? currentRoles.ass.collection + ' #' + currentRoles.ass.id : 'Not Set')}  </p>
    <p style={{color:'#000',fontWeight:'bold', textAlign:'center',maxWidth:'152px'}}>{(currentRoles.ass !== undefined && Object.keys(currentRoles.ass).length > 0 ? 'S:' + (currentRoles.ass.speedTotal + getManagementStyleBonuses(selectedManagement, 0,0, "speed") + (weekInfo.weekinfo.regatta === "1" && currentRoles.ass.roleName === "Captain" ? ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' ? 3 : -3) : currentRoles.ass.roleBoost)  + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.bNum : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ass.raceid === 1 ? currentRoles.ass.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.wBoostB : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ass.raceid === 1  ? currentRoles.ass.wBoostBHi: currentRoles.ass.wBoostBLo))) + ' A:' + (currentRoles.ass.accelTotal + getManagementStyleBonuses(selectedManagement, currentRoles.ass.accelTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.wBoostA : (accountDetails.hilo === 'hi' || currentRoles.ass.raceId === "1" ? currentRoles.ass.wBoostAHi: currentRoles.ass.wBoostALo))),"accel") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.wBoostA : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ass.raceid === 1 ? currentRoles.ass.wBoostAHi: currentRoles.ass.wBoostALo))) +  ' E:' + (currentRoles.ass.endurTotal + getManagementStyleBonuses(selectedManagement, currentRoles.ass.endurTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.wBoostE : (accountDetails.hilo === 'hi' || currentRoles.ass.raceId === "1" ? currentRoles.ass.wBoostEHi: currentRoles.ass.wBoostELo))),"endur") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ass.wBoostE : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ass.raceid === 1 ? currentRoles.ass.wBoostEHi: currentRoles.ass.wBoostELo))) : '')}</p>
    <p style={{textAlign:'center'}}>{(currentRoles.ass !== undefined && Object.keys(currentRoles.ass).length > 0  ? (currentRoles.ass.pending === "yes" ? "Pending" : "") + (prevSetRoles.ass !== undefined && Object.keys(prevSetRoles.ass).length > 0 && prevSetRoles.ass !== currentRoles.ass ? " replacing " + prevSetRoles.ass.id  : "" ): "")}</p>
    </div>
<div style={{textAlign:'center'}}><img src={pearlimg} alt="pearl logo" style={{width:'30px'}} /> 100</div>
</div>
        </div>
        <div className='col-md-2' style={{display:(weekInfo.weekinfo.regatta === "1" &&  ((regInfo.league === "1" && accountDetails.hilo === 'lo') || (regInfo.league === "3" && accountDetails.hilorookie === 'lo')) ? 'none' : 'unset')}}>
        <div className="col" style={{maxWidth:'180px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)',textAlign:'center', fontSize:'.8em', color:'black', fontWeight:'bold'}}>
    <div style={{paddingTop:'6px', paddingBottom:'6px'}}>Anchor (+4)<br/><img src={anchorimg} style={{width:'20px', marginLeft:'5px', marginRight:'5px'}} alt="anchor role"  /></div>
    <img src={(currentRoles.anc !== undefined && Object.keys(currentRoles.anc).length > 0 ? currentRoles.anc.image : unsetrole)} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={(currentRoles.anc !== undefined && Object.keys(currentRoles.anc).length > 0 ? 'anchor image' : 'anchor unset')}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{(currentRoles.anc !== undefined && Object.keys(currentRoles.anc).length > 0  ? currentRoles.anc.collection + ' #' + currentRoles.anc.id : 'Not Set') }  </p>
    <p style={{color:'#000',fontWeight:'bold', textAlign:'center',maxWidth:'152px'}}>{(currentRoles.anc !== undefined && Object.keys(currentRoles.anc).length > 0 ? 'S:' + (currentRoles.anc.speedTotal + getManagementStyleBonuses(selectedManagement, 0,0, "speed") + (weekInfo.weekinfo.regatta === "1" && currentRoles.anc.roleName === "Captain" ? ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' ? 3 : -3) : currentRoles.anc.roleBoost)  + (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.bNum : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.anc.raceid === 1 ? currentRoles.anc.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.wBoostB : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.anc.raceid === 1  ? currentRoles.anc.wBoostBHi: currentRoles.anc.wBoostBLo))) + ' A:' + (currentRoles.anc.accelTotal + getManagementStyleBonuses(selectedManagement, currentRoles.anc.accelTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.wBoostA : (accountDetails.hilo === 'hi' || currentRoles.anc.raceId === "1" ? currentRoles.anc.wBoostAHi: currentRoles.anc.wBoostALo))),"accel") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.wBoostA : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.anc.raceid === 1 ? currentRoles.anc.wBoostAHi: currentRoles.anc.wBoostALo))) +  ' E:' + (currentRoles.anc.endurTotal + getManagementStyleBonuses(selectedManagement, currentRoles.anc.endurTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.wBoostE : (accountDetails.hilo === 'hi' || currentRoles.anc.raceId === "1" ? currentRoles.anc.wBoostEHi: currentRoles.anc.wBoostELo))),"endur") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.anc.wBoostE : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.anc.raceid === 1 ? currentRoles.anc.wBoostEHi: currentRoles.anc.wBoostELo))) : '')}</p>
    <p style={{textAlign:'center'}}>{(currentRoles.anc !== undefined && Object.keys(currentRoles.anc).length > 0  ? (currentRoles.anc.pending === "yes" ? "Pending" : "") + (prevSetRoles.anc !== undefined && Object.keys(prevSetRoles.anc).length > 0 && prevSetRoles.anc !== currentRoles.anc ? " replacing " + prevSetRoles.anc.id  : "" ): "")}</p>
    </div>
<div style={{textAlign:'center'}}><img src={pearlimg} alt="pearl logo" style={{width:'30px'}} /> 250</div>
</div>

        </div>
        
        <div className='col-md-2' style={{display:(weekInfo.weekinfo.regatta === "1" &&  ((regInfo.league === "1" && accountDetails.hilo === 'hi') || (regInfo.league === "3" && accountDetails.hilorookie === 'hi')) ? 'none' : 'unset')}}>
        <div className="col" style={{maxWidth:'180px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)',textAlign:'center', fontSize:'.8em', color:'black', fontWeight:'bold'}}>
    <div style={{paddingTop:'6px', paddingBottom:'6px'}}>Bench Warmer (-1)<img src={benchimg} style={{width:'20px', marginLeft:'5px', marginRight:'5px'}} alt="bench role"  /></div>
    <img src={(currentRoles.ben !== undefined && Object.keys(currentRoles.ben).length > 0 ? currentRoles.ben.image : unsetrole)} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={(currentRoles.ben !== undefined && Object.keys(currentRoles.ben).length > 0 ? 'benchwarmer image' : 'benchwarmer unset')}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{(currentRoles.ben !== undefined && Object.keys(currentRoles.ben).length > 0  ? currentRoles.ben.collection + ' #' + currentRoles.ben.id : 'Not Set')}  </p>
    <p style={{color:'#000',fontWeight:'bold', textAlign:'center',maxWidth:'152px'}}>{(currentRoles.ben !== undefined && Object.keys(currentRoles.ben).length > 0 ? 'S:' + (currentRoles.ben.speedTotal + getManagementStyleBonuses(selectedManagement, 0,0, "speed") + (weekInfo.weekinfo.regatta === "1" && currentRoles.ben.roleName === "Captain" ? ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' ? 3 : -3) : currentRoles.ben.roleBoost)  + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.bNum : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ben.raceid === 1 ? currentRoles.ben.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.wBoostB : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ben.raceid === 1  ? currentRoles.ben.wBoostBHi: currentRoles.ben.wBoostBLo))) + ' A:' + (currentRoles.ben.accelTotal + getManagementStyleBonuses(selectedManagement, currentRoles.ben.accelTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.wBoostA : (accountDetails.hilo === 'hi' || currentRoles.ben.raceId === "1" ? currentRoles.ben.wBoostAHi: currentRoles.ben.wBoostALo))),"accel") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.wBoostA : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ben.raceid === 1 ? currentRoles.ben.wBoostAHi: currentRoles.ben.wBoostALo))) +  ' E:' + (currentRoles.ben.endurTotal + getManagementStyleBonuses(selectedManagement, currentRoles.ben.endurTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.wBoostE : (accountDetails.hilo === 'hi' || currentRoles.ben.raceId === "1" ? currentRoles.ben.wBoostEHi: currentRoles.ben.wBoostELo))),"endur") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.ben.wBoostE : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.ben.raceid === 1 ? currentRoles.ben.wBoostEHi: currentRoles.ben.wBoostELo))) : '')}</p>
    <p style={{textAlign:'center'}}>{(currentRoles.ben !== undefined && Object.keys(currentRoles.ben).length > 0  ? (currentRoles.ben.pending === "yes" ? "Pending" : "") + (prevSetRoles.ben !== undefined && Object.keys(prevSetRoles.ben).length > 0 && prevSetRoles.ben !== currentRoles.ben ?  ' replacing ' + prevSetRoles.ben.id  : "" ): "")}</p>
    </div>
<div style={{textAlign:'center'}}><img src={pearlimg} alt="pearl logo" style={{width:'30px'}} /> 100</div>
</div>

        </div>
        <div className='col-md-2' style={{display:(weekInfo.weekinfo.regatta === "1" &&  ((regInfo.league === "1" && accountDetails.hilo === 'hi') || (regInfo.league === "3" && accountDetails.hilorookie === 'hi')) ? 'none' : 'unset')}}>
        <div className="col" style={{maxWidth:'180px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)',textAlign:'center', fontSize:'.8em', color:'black', fontWeight:'bold'}}>
    <div style={{paddingTop:'6px', paddingBottom:'6px'}}>Equip. Manager (-2) <img src={equipimg} style={{width:'20px', marginLeft:'5px', marginRight:'5px'}} alt="equipment role" /></div>
    <img src={(currentRoles.equ !== undefined && Object.keys(currentRoles.equ).length > 0 ? currentRoles.equ.image : unsetrole)} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={(currentRoles.equ !== undefined && Object.keys(currentRoles.equ).length > 0 ? 'equipment manager image' : 'equipment mananager unset')}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{(currentRoles.equ !== undefined && Object.keys(currentRoles.equ).length > 0  ? currentRoles.equ.collection + ' #' + currentRoles.equ.id : 'Not Set')}  </p>
    <p style={{color:'#000', fontWeight:'bold', textAlign:'center',maxWidth:'152px'}}>{(currentRoles.equ !== undefined && Object.keys(currentRoles.equ).length > 0 ? 'S:' + (currentRoles.equ.speedTotal + getManagementStyleBonuses(selectedManagement, 0,0, "speed") + (weekInfo.weekinfo.regatta === "1" && currentRoles.equ.roleName === "Captain" ? ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' ? 3 : -3) : currentRoles.equ.roleBoost)  + (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.bNum : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.equ.raceid === 1 ? currentRoles.equ.bNum : 0)) + (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.wBoostB : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.equ.raceid === 1  ? currentRoles.equ.wBoostBHi: currentRoles.equ.wBoostBLo))) + ' A:' + (currentRoles.equ.accelTotal + getManagementStyleBonuses(selectedManagement, currentRoles.equ.accelTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.wBoostA : (accountDetails.hilo === 'hi' || currentRoles.equ.raceId === "1" ? currentRoles.equ.wBoostAHi: currentRoles.equ.wBoostALo))),"accel") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.wBoostA : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.equ.raceid === 1 ? currentRoles.equ.wBoostAHi: currentRoles.equ.wBoostALo))) +  ' E:' + (currentRoles.equ.endurTotal + getManagementStyleBonuses(selectedManagement, currentRoles.equ.endurTotal,(leagueToManage === "3" && weekInfo.weekinfo.regatta === "0" ? 0 : (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.wBoostE : (accountDetails.hilo === 'hi' || currentRoles.equ.raceId === "1" ? currentRoles.equ.wBoostEHi: currentRoles.equ.wBoostELo))),"endur") + (weekInfo.weekinfo.regatta === "0" ? currentRoles.equ.wBoostE : ((leagueToManage === "1" ? accountDetails.hilo : accountDetails.hilorookie) === 'hi' || currentRoles.equ.raceid === 1 ? currentRoles.equ.wBoostEHi: currentRoles.equ.wBoostELo))) : '')}</p>
    <p style={{textAlign:'center'}}>{(currentRoles.equ !== undefined && Object.keys(currentRoles.equ).length > 0  ? (currentRoles.equ.pending === "yes" ? "Pending" : "") + (prevSetRoles.equ !== undefined && Object.keys(prevSetRoles.equ).length > 0 && prevSetRoles.equ !== currentRoles.equ ? " replacing " + prevSetRoles.equ.id  : "" ) : "")}</p>
    </div>
<div style={{textAlign:'center'}}><img src={pearlimg} alt="pearl logo" style={{width:'30px'}} /> 200</div>
</div>
        </div>
        <div className='col-md-2'></div>
        <NFTGridRolesSelectable nftArray={racerArray} nftType={'racers'}  selectRole={selectRole} selectedRoles={currentRoles} selItems={roleSelItems} setSelItems={setRoleSelItems} leagueToManage={leagueToManage} weekInfo={weekInfo} hilo={(regInfo.league === "1" ? accountDetails.hilo : accountDetails.hilorookie)} managestyle={selectedManagement} /> 
    </div>
    
    <div className='col-md-12 createFormat row' style={{marginTop:'40px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'changes' ? 'flex' : 'none')}}><div className='col-md-3'><span style={{fontSize:'.9em'}}></span><div style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', fontWeight:'bold'}}>Changes:</div></div><div className='col-md-3' style={{fontSize:'1.1em'}}></div><div className='col-md-6' style={{textAlign:'right'}}> <button id="changessubmitButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(selectChanges.length > 0  ? "unset" : "none")}} className='btn' onClick={() => submitChanges()}><span>apply updates</span></button><button id="changeCancelButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(selectChanges.length > 0 ? "unset" : "none")}} className='btn' onClick={() => cancelChanges()}><span>cancel changes</span></button></div></div>
        <div className='col-md-12 createFormat row' style={{ paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'changes' ? 'flex' : 'none')}}>
      
        <div className='col-md-12 createFormat row' style={{ marginRight:'10px', paddingTop:'10px', marginTop:'30px', backgroundColor: 'rgba(0, 0, 0, 0.3)', opacity:(leagueToManage === '3' ? '.4': '1')}}>
            <div className='col-md-5' style={{paddingTop:'10px', fontSize:'1.1em'}}>Assign Hydrolyte <img src={hydroimg} alt={'hydro logo'} style={{width:'25px', margin:'4px'}}/><span style={{fontStyle:'italic'}}></span></div>
            <div className='col-md-7' style={{textAlign:'right', fontSize:'.9em'}}><img src={plus} alt="increase endurance" style={{width:'40px', cursor:'pointer'}} onClick={() => increaseEndurance()}/> Total Available: <span style={{fontWeight:'bold'}}>{(regInfo.league === "3" ? "0" : parseInt(leagueHydro[leagueToManage]))}</span> <img src={minus} alt="decrease endurance" style={{width:'40px', cursor:'pointer'}} onClick={() => decreaseEndurance()}/></div>
        </div>
        <NFTGridChangesSelectable nftArray={racerArray} nftType={'racers'}  setSelectChanges={setSelectChanges} selectedRoles={currentRoles} leagueToManage={leagueToManage} selectChanges={selectChanges} setMoveTo={setMoveTo} unRegisterRacers={unRegisterRacers} moveTo={moveTo} selItems={changesSelItems} setSelItems={setChangeSelItems} weekInfo={weekInfo} hilo={(regInfo.league === "1" ? accountDetails.hilo : accountDetails.hilorookie)} managestyle={selectedManagement} pendingHydroRacers={pendingHydroRacers}/> 
    </div>
    <div className='col-md-12 createFormat row' style={{marginTop:'40px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'mystery' ? 'flex' : 'none')}}><div className='col-md-6'><span style={{fontSize:'.9em'}}></span><div style={{fontSize:'1.1em', marginTop:'5px', marginBottom:'5px', fontWeight:'bold'}}>Mystery Buff: <span style={{fontStyle:'italic', fontWeight:'normal'}}>(Coming soon)</span></div></div><div className='col-md-6' style={{textAlign:'right'}}> </div></div>
        <div className='col-md-12 createFormat row' style={{ paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'mystery' ? 'flex' : 'none')}}>
      
        <div className='col-md-12 createFormat row' style={{ marginRight:'10px', paddingTop:'10px', marginTop:'30px', backgroundColor: 'rgba(0, 0, 0, 0.3)', opacity:'.4'}}>
            <div className='col-md-6' style={{paddingTop:'10px', fontSize:'1.1em'}}>Racers selected: <span style={{fontWeight:'bold'}}>({selectMystery.length})</span></div>
            <div className='col-md-6' style={{paddingTop:'10px',textAlign:'right', fontSize:'1.1em'}}><button id="mysteryspinButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(selectMystery.length > 0  ? "unset" : "none"), fontWeight:'bold'}} className='btn' onClick={() => spinMystery('initial')}><span>Spin</span></button><button id="mysteryrespinButton" type="button" style={{marginRight:'5%',width:'160px', color:'white', display:(selectMystery.length > 0 ? "unset" : "none"), fontWeight:'bold', backgroundColor:'#0d6efd'}} className='btn' onClick={() => spinMystery('respin')}><span>Re-spin</span></button></div>
            <div className='col-md-4' style={{paddingTop:'20px', fontSize:'1.1em'}}>Price per racer:</div>
            <div className='col-md-2' style={{paddingTop:'15px', fontSize:'1.1em'}}><img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/><span style={{fontWeight:'bold'}}>0</span></div>
            <div className='col-md-4' style={{paddingTop:'20px', fontSize:'1.1em'}}> Total: (this spin) </div>
            <div className='col-md-2' style={{paddingTop:'15px', fontSize:'1.1em'}}><img src={pearlimg} alt={'pearl logo'} style={{width:'35px'}}/>{selectMystery.length * 0}</div>

        </div>
        <NFTGridMysterySelectable nftArray={racerArray} nftType={'racers'}  setSelectMystery={setSelectMystery} selectedRoles={currentRoles} selItems={mysterySelItems} setSelItems={setMysterySelItems} leagueToManage={leagueToManage} weekInfo={weekInfo} hilo={(regInfo.league === "1" ? accountDetails.hilo : accountDetails.hilorookie)} managestyle={selectedManagement} /> 
    </div>
    
        <div className='col-md-12 createFormat row' style={{ paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'overview' && coachChange === "no" ? 'flex' : 'none')}}>
            <div className='col-md-3'>
        <div className="col" style={{maxWidth:'120px'}}>
<div className="image-box" style={{backgroundColor:'rgb(204, 204, 204)'}}>
    <img src={selectedCoach.image} style={{paddingLeft:'5px', paddingTop:'5px', paddingRight:'5px'}} className="card-img-top" loading="lazy" alt={selectedCoach.image}  />
</div>
<div className="card-body" style={{padding:'0px', backgroundColor: 'rgb(204, 204, 204)'}}>
    <p className="card-text" style={{color:'#000', fontWeight:'bold', textAlign:'center', fontSize:'.9em',paddingTop:'10px', marginBottom:'0px'}}>{selectedCoach.collection} #{selectedCoach.id} </p>
    <p style={{textAlign:'center', marginBottom:'5px'}}>{(selectedCoach.levelarr !== undefined ? selectedCoach.levelarr.map(function(lvl, x){return <img src={star} alt="ranks" style={{width:'25px', paddingLeft:'2px', paddingRight:'2px'}} key={x} />}) : '')}</p>
    <p style={{textAlign:'center',}}><span style={{color:'black', fontSize:'.8em'}}>Reef Points: {selectedCoach.reefpoints}</span></p>
</div>
<div><button id="coachchangeButton" type="button" style={{marginRight:'5%',width:'120px', backgroundColor:'#1A7AE6',color:'white', fontSize:'.8em'}} className='btn' onClick={()=> changeCoachSel()}><span>Change</span></button></div>
</div>
            
            </div>
<div className='col-md-3' style={{paddingTop:'10px'}}><div><span style={{color:'gray'}}>Management style:</span></div><div style={{paddingTop:'20px'}}>Coach:</div><div style={{paddingTop:'20px'}}>{(registeredCoach.baseboostshrt !== undefined ? registeredCoach.baseboostshrt : '')}</div><div>{(registeredCoach.legboostshrt !== undefined ? registeredCoach.legboostshrt  : '')}</div>
<div>{(registeredCoach.skinboostshrt !== undefined ? registeredCoach.skinboostshrt : '')}</div><div>{(registeredCoach.ttboostshrt !== undefined ? registeredCoach.ttboostshrt : '')}</div>
<div>{(registeredCoach.oceanboostshrt !== undefined ? registeredCoach.oceanboostshrt  : '')}</div>
<div>{(registeredCoach.hemiboostshrt !== undefined ? registeredCoach.hemiboostshrt : '')}</div>
<div>{(registeredCoach.tfboostshrt !== undefined ? registeredCoach.tfboostshrt : '')}</div>

</div>
<div className='col-2' style={{paddingTop:'10px', minWidth:'120px'}}><div style={{display:(weekInfo.weekinfo.regatta === "1" || leagueToManage == "3" ? 'block' : "none")}}>Not Available</div><div style={{display:(weekInfo.weekinfo.regatta === "1" || leagueToManage === "3" ? 'none' : "block")}}><select onChange={(event) => setManageStyle(event.target.value)} value={selectedManagement}><option value="0">No Style</option>{managementStyles.map((style,i)=> (<option key={i} value={style.contract}>{style.name} ({style.desc})</option>))}</select></div><div style={{paddingTop:'20px'}}>Racers:</div>
<div style={{paddingTop:'10px', color:'rgba(227, 81, 185, 1)', display:(weekInfo.weekinfo.regatta === "1" || weekInfo.weekinfo.sharkweek === "1" ? 'none' : "block")}}>TOTW:</div>
<div style={{paddingTop:'10px', color:'rgba(238, 47, 47, 1)', display:(weekInfo.weekinfo.regatta === "1" ? 'none' : "block")}}>{(weekInfo.weekinfo.sharkweek === "1" ? "Tier 3" : "Tiers")}:</div>
<div style={{paddingTop:'10px', color:'rgba(229, 169, 26, 1)'}}>{(weekInfo.weekinfo.regatta === "1" ? 'Alternate' : (weekInfo.weekinfo.sharkweek === "1" ? "Tier 2" : "Hi-Lo"))}:</div>
<div style={{paddingTop:'10px', color:'rgba(218, 229, 26, 1)'}}>{(weekInfo.weekinfo.regatta === "1" ? 'Regatta' : (weekInfo.weekinfo.sharkweek === "1" ? "Tier 1" : "FFA"))}:</div>
</div>
<div className='col-1' style={{paddingTop:'10px'}}><div></div><div style={{paddingTop:'43px', textAlign:'center'}}><span style={{fontWeight:'bold'}}>({stakedRacers.filter(x => parseInt(x.league) === parseInt(leagueToManage) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length})</span></div>
<div style={{paddingTop:'9px', textAlign:'center', display:(weekInfo.weekinfo.regatta === "1" ? 'none' : "block")}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 22 && parseInt(x.league) === parseInt(leagueToManage) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'9px', textAlign:'center', display:(weekInfo.weekinfo.regatta === "1" ? 'none' : "block")}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) > 1 && parseInt(x.eventWanted) < 22 && parseInt(x.league) === parseInt(leagueToManage) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'9px', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 1 && parseInt(x.league) === parseInt(leagueToManage) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
<div style={{paddingTop:'9px', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{stakedRacers.filter(x => parseInt(x.eventWanted) === 0 && parseInt(x.league) === parseInt(leagueToManage) && x.owner.toLowerCase() === walletAddress.toLowerCase()).length}</span></div>
</div> 
<div className='col-2' style={{paddingTop:'10px', minWidth:'120px'}}>
<div><button id="stylechangeButton" type="button" style={{marginRight:'5%', backgroundColor:'#1A7AE6',color:'white', fontSize:'.7em', display:(selectedManagement === "" || parseInt(selectedManagement) === parseInt(currentSelManageStyle[leagueToManage]) ? 'none' : 'block')}} className='btn' onClick={()=> updateManageStyleSel()}><span>Apply Style</span></button></div>    
<div style={{paddingTop:(selectedManagement === "" || parseInt(selectedManagement) === parseInt(currentSelManageStyle[leagueToManage]) ? '43px' : '12px')}}>Speed:</div>
<div style={{paddingTop:'10px'}}>Average:</div>
<div style={{paddingTop:'10px'}}>Highest:</div>
<div style={{paddingTop:'10px'}}>Lowest:</div>
</div>
<div className='col-1' style={{paddingTop:'10px'}}><div style={{paddingTop:'43px'}}><span style={{fontWeight:'bold'}}></span></div>
<div style={{marginTop:'34px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.average}</span></div>
<div style={{paddingTop:'10px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.highest}</span></div>
<div style={{paddingTop:'10px', width:'20px', backgroundColor:'rgba(0, 0, 0, 0.5)', textAlign:'center'}}><span style={{fontWeight:'bold'}}>{confirmStats.lowest}</span></div>
</div>                
            </div>
            <div className='col-md-12' id='changeCoach' style={{display:(currManagementSel === 'overview' && coachChange === "yes" ? 'inline' : 'none')}}>
            <NFTGridCoachSelectable nftArray={coachArray} nftType={'coach'} maxSel={1} setSelectedItems={setSelectedCoach} selectedItems={selectedCoach.id}/>
                    </div>
                    <div style={{textAlign:'center',marginBottom:'20px', height:'40px'}}><button id="coachselButton" type="button" style={{marginRight:'5%',width:'160px', display:(currManagementSel !== 'overview' || (currManagementSel === 'overview' && coachChange === "yes") ? 'none' : 'inline-block')}} className='btn btn-primary' onClick={() => goToManage('roles')}><span>Roles</span></button></div>
                    <div style={{textAlign:'center',marginBottom:'10px', height:'30px', display:(currManagementSel === 'overview' && coachChange === "yes" ? 'block' : 'none')}}><button id="coachselButton" type="button" style={{marginRight:'5%',width:'140px', fontSize:'.9em', display:(Object.keys(selectedCoach).length === 0 || selectedCoach === registeredCoach ? 'none' : 'inline-block')}} className='btn btn-primary' onClick={()=>updateManageCoach()}><span>Update Coach</span></button><button id="coachUpCancel" type="button" style={{marginRight:'5%',width:'140px', fontSize:'.9em'}} className='btn btn-primary' onClick={() => cancelCoachUp()}><span>Cancel Update</span></button></div>
                    <div className='col-md-12 createFormat row' style={{marginTop:'40px', paddingLeft:'40px', paddingRight:'10px', marginRight:'10px', display:(currManagementSel === 'roles' ? 'flex' : 'none')}}><div className='col-md-6'></div><div className='col-md-6' style={{textAlign:'right'}}> <button id="rolesubmitButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(pendingRoleChanges === "yes" ? "unset" : "none")}} className='btn' onClick={() => submitRoles()}><span>Apply Roles</span></button><button id="roleCancelButton" type="button" style={{marginRight:'5%',width:'160px',backgroundColor:'#37780E', color:'white', display:(pendingRoleChanges === "yes" ? "unset" : "none")}} className='btn' onClick={() => cancelRoleChng()}><span>Cancel Role Changes</span></button></div></div>
                    <div style={{textAlign:'center',marginBottom:'20px', height:'40px'}}><button id="coachselButton" type="button" style={{marginRight:'5%',width:'160px', display:(currManagementSel !== 'roles' ? 'none' : 'inline-block')}} className='btn btn-primary' onClick={() => goToManage('changes')}><span>Changes</span></button></div>
    </div>
     }
    }
    }else if (menuSelection === 'leaderboard'){

return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px', textAlign:'center'}}>
                <LeaderBoard weeks={weeks.leaderboard} />
            </div>
    } else if (menuSelection === 'raceresults'){
        return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px', textAlign:'center'}}>
                <Lobby weeks={weeks.lobby} walletAddress={walletAddress}/>
            </div>
    } else if (menuSelection === 'records'){
        return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px', textAlign:'center'}}>
                <ViewRecords />
            </div>
    }  else if (menuSelection === 'contest'){
        return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px', textAlign:'center'}}>
                <CoachContest />
            </div>
    }else if (menuSelection === 'mints'){
        if (walletAddress === ''){
            return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access mints.</div>)
    }else{  
        return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px',paddingLeft:'30px', textAlign:'center'}}>
                <MintPanel walletAddress={walletAddress} setModalInfo={setModalInfo}/>
            </div>
    }
    } else if (menuSelection === 'lfg'){
        if (walletAddress === ''){
            return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access looking for functions.</div>)
    }else{  
    return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px',paddingLeft:'30px', textAlign:'center'}}>
                <LookingFor walletAddress={walletAddress} setModalInfo={setModalInfo} racerArray={collectionslist[1].racers}/>
            </div>
    }
    } else if (menuSelection === 'transfers'){
        if (walletAddress === ''){
            return (<div style={{color:'white', paddingLeft:'50px', paddingTop:'60px'}}>Please connect wallet to access transfers.</div>)
    }else{  
        return <div className='col-md-12 row' style={{paddingTop:'30px', paddingBottom:'30px',paddingLeft:'30px', textAlign:'center'}}>
                    <TransferManagement walletAddress={walletAddress} setModalInfo={setModalInfo} transfersAllowed={transfersAllowed} setTransfersAllowed={setTransfersAllowed}  getTransferStatus={getTransferStatus} transferFavs={transferFavs} setTransferFavs={setTransferFavs} transferWallets={transferWallets} setTransferWallets={setTransferWallets} getWalletsForTransfer={getWalletsForTransfer} getTransferFavs={getTransferFavs} checkTransferStatus={checkTransferStatus} transferAllAllowed={transferAllAllowed} setTransferAllAllowed={setTransferAllAllowed} getAllTransferStatus={getAllTransferStatus}/>
                </div>
    }
        }

}

export {MenuDisplay};